/*
SELECT 
    concat('BIB_',
    upper(CONCAT(TRIM(REPLACE(REPLACE(REPLACE(
    REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(
    REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(
    REPLACE(REPLACE(REPLACE(descricao, ' ', '')
    ,'â','a'), 'ç', 'c'), 'á', 'a'), 'é', 'e')
    , 'í', 'i'), 'ó', 'o'), 'õ', 'o')
    , 'ê', 'e'), 'ã', 'a'), '-', '')
    , '(', ''), ')', ''), '/', '')
    , '.', ''), 'ô', 'o'))
    , '_Menu_', SegMenuId, ' = ', SegMenuId, ','))) AS descricao_limpa
FROM 
    seg_menu 
WHERE 
    menu = 0 and SegMenuId like '1300%'
*/
export enum eTipoPermissao {
  PUBLICA = 99999999999,
  CONTRATOS_MENU_100100100 = 100100100,
  NOTIFICACOES_MENU_100100200 = 100100200,
  SISTEMABASE_MENU_190000001 = 190000001,
  CALENDARIODAREDEDEENSINO_MENU_200100100 = 200100100,
  CRIARCALENDARIO_MENU_200100200 = 200100200,
  ATIVIDADES_MENU_200200100 = 200200100,
  FERIADOS_MENU_200300100 = 200300100,
  PARALISACOES_MENU_200300200 = 200300200,
  CALENDARIO_MENU_200400100 = 200400100,
  FERIADOS_MENU_200500100 = 200500100,
  PARALISACOES_MENU_200500200 = 200500200,
  AGENDA_MENU_200600000 = 200600000,
  ACESSARMENUCADASTROS_MENU_290000001 = 290000001,
  ACESSARMENUCALENDARIO_MENU_290000002 = 290000002,
  ACESSARMENURELATORIOS_MENU_290000003 = 290000003,
  CADASTRARATIVIDADES_MENU_290000004 = 290000004,
  CADASTRARFERIADOS_MENU_290000005 = 290000005,
  EMITIRCALENDARIO_MENU_290000006 = 290000006,
  EMITIROUTROSRELATORIOS_MENU_290000007 = 290000007,
  PREENCHERCALENDARIO_MENU_290000008 = 290000008,
  SISTEMACALENDARIO_MENU_290000009 = 290000009,
  VISUALIZAROCORRENCIAS_MENU_300100100 = 300100100,
  DADOSDOESTUDANTE_MENU_300100200 = 300100200,
  DADOSDOESTUDANTE_MENU_300100202 = 300100202,
  INFORMACOESCOMPLEMENTARES_MENU_300100300 = 300100300,
  OCORRENCIASDOESTUDANTE_MENU_300100400 = 300100400,
  ATESTADOSDOESTUDANTE_MENU_300100500 = 300100500,
  RESPONSAVELESTUDANTEPORTURMA_MENU_300100600 = 300100600,
  ENVIAREMAILPARAESTUDANTEPAIS_MENU_300100700 = 300100700,

  /*
   * TELAS NOVAS do grupo "Estudantes" — cada uma com permissão PRÓPRIA, vizinha da do legado e
   * nunca ela (ver CLAUDE.md, "Permissão de tela nova — nunca reusar a do legado"). O INSERT na
   * Seg_Menu está em `saeweb-database-sql/consultebase/scripts/2026-09-29-Permissoes-Estudantes.sql`.
   *
   * A 300100399 é de AÇÃO (somentePermissao = 1): as Informações Complementares deixaram de ser
   * uma janela e viraram uma seção DENTRO do cadastro do estudante, então não há rota para ela.
   * As de 300100549 e 300100599 não seguem o "x99" porque a 300100550 (Encaminhamentos, legado)
   * divide o bloco dos Atestados (300100500): cada tela nova fica na metade do seu legado.
   */
  INFORMACOESCOMPLEMENTARESNOVO_MENU_300100399 = 300100399,
  OCORRENCIASDOESTUDANTENOVO_MENU_300100499 = 300100499,
  ATESTADOSDOESTUDANTENOVO_MENU_300100549 = 300100549,
  ENCAMINHAMENTOSNOVO_MENU_300100599 = 300100599,
  RESPONSAVELESTUDANTEPORTURMANOVO_MENU_300100699 = 300100699,
  ENVIAREMAILPARAESTUDANTEPAISNOVO_MENU_300100799 = 300100799,

  /*
   * REGISTROS DE HIGIENE (trocas de fralda e evacuações) — exigência do edital.
   *
   * Duas permissões, e não uma: quem LANÇA é a professora do berçário, quem VÊ no portal é o
   * responsável. São públicos diferentes e a rede precisa liberar um sem o outro — por
   * exemplo, começar registrando internamente e só abrir para os pais quando a rotina estiver
   * consolidada.
   */
  /** Tela de secretaria: lançar e corrigir os registros da turma. */
  REGISTROSDEHIGIENE_MENU_300100800 = 300100800,
  /** Seção "Higiene" nas Homes do estudante e do responsável. */
  REGISTROSDEHIGIENEPORTAL_MENU_300100801 = 300100801,

  /*
   * AUTORIZAÇÕES ELETRÔNICAS — exigência do edital. Mesma divisão: a escola PUBLICA o
   * documento, o responsável ASSINA. Liberar a publicação não pode implicar liberar a
   * assinatura, nem o contrário.
   */
  /** Tela de secretaria: criar, publicar e acompanhar as autorizações. */
  AUTORIZACOESELETRONICAS_MENU_300100900 = 300100900,
  /** Seção "Autorizações" nas Homes do estudante e do responsável. */
  AUTORIZACOESELETRONICASPORTAL_MENU_300100901 = 300100901,
  REMATRICULA_MENU_300200100 = 300200100,
  MATRICULA_MENU_300200200 = 300200200,
  MATRICULA_MENU_300200201 = 300200201,
  REMATRICULA_MENU_300200301 = 300200301,
  /** Consulta das rematrículas feitas pelo RESPONSÁVEL no portal, com a 2ª via do recibo. */
  REMATRICULASRESPONSAVELNOVO_MENU_300200302 = 300200302,
  REMATRICULA_MENU_300200300 = 300200300,
  REGISTRODEENTREGADEREMATRICULA_MENU_300200400 = 300200400,
  /** Registro de entrega de rematrícula — tela nova (migração de `ControleRematricula.aspx`). */
  REGISTRODEENTREGADEREMATRICULANOVO_MENU_300200499 = 300200499,
  CONSULTAESPERADEMATRICULAS_MENU_300200500 = 300200500,
  RECEBIMENTODEPREMATRICULAS_MENU_300200600 = 300200600,
  RECEBIMENTODEPREMATRICULASPROJOVEM_MENU_300200700 = 300200700,
  /*
   * FILA DE ESPERA / PRÉ-MATRÍCULA — telas novas (docs/fila-espera-prematricula/). Permissões
   * PRÓPRIAS, vizinhas das legadas; as duas de AÇÃO (somentePermissao = 1) ficam penduradas na
   * tela do Recebimento e liberam as ações em lote.
   */
  /** Consulta Espera de Matrículas (rede) — migração de `FilaDeEsperaConsulta.aspx`. */
  CONSULTAESPERADEMATRICULASNOVO_MENU_300200599 = 300200599,
  /** Recebimento de Pré-Matrículas — migração de `FilaDeEspera.aspx` + `PreMatriculaCheckList2.aspx`. */
  RECEBIMENTODEPREMATRICULASNOVO_MENU_300200699 = 300200699,
  /** Ação: "Matricular todos" do Recebimento. */
  RECEBIMENTOPREMATRICULASMATRICULARTODOSNOVO_MENU_300200698 = 300200698,
  /** Ação: "Recusar por prazo" (três dias úteis) do Recebimento. */
  RECEBIMENTOPREMATRICULASREJEITARTEMPONOVO_MENU_300200697 = 300200697,
  /** Recebimento de Pré-Matrículas Pró-Jovem — migração de `FilaProJovem.aspx` + `DetalhesProJovem.aspx`. */
  RECEBIMENTODEPREMATRICULASPROJOVEMNOVO_MENU_300200799 = 300200799,
  SITUACAODAMATRICULA_MENU_300200800 = 300200800,
  DOCUMENTACAO_MENU_300200900 = 300200900,
  APRESENTACAO_MENU_300200902 = 300200902,
  COMPROVANTES_MENU_300201100 = 300201100,
  TRAJETORIADEMATRICULA_MENU_300201300 = 300201300,
  REQUERIMENTODEMATRICULA_MENU_300201400 = 300201400,
  FICHADEMATRICULA_MENU_300201500 = 300201500,
  DIARIO_MENU_300300010 = 300300010,
  PET_MENU_300300020 = 300300020,
  EMISSAODETALETASDOPROFESSOR_MENU_300300100 = 300300100,
  EMISSAODETALETASDOPROFESSOR_MENU_300300200 = 300300200,
  RELACAODEESTUDANTES_MENU_300300300 = 300300300,
  PETETAPAS_MENU_300300400 = 300300400,
  EMISSAODEDIARIOELETRONICO_MENU_300300500 = 300300500,
  // Telas NOVAS do diario. Permissao PROPRIA, nunca a do legado (300300500): enquanto as duas
  // versoes convivem, a rede precisa liberar uma sem a outra.
  // 502 = Diario de Classe (professor); 503 = Caderno da Turma (supervisao).
  EMISSAODEDIARIOELETRONICONOVO_MENU_300300502 = 300300502,
  EMISSAODECADERNODATURMANOVO_MENU_300300503 = 300300503,
  PAINELPENDENCIAS_MENU_300300504 = 300300504,
  EMISSAODEDIARIO_MENU_300300700 = 300300700,
  FORMULARIODEFREQUENCIAPROVISORIO_MENU_300300800 = 300300800,
  EMISSAODEDIARIOSEDUC_MENU_300301000 = 300301000,
  NOMECONTEUDOLECIONADO_MENU_300301200 = 300301200,
  ESTUDOSCOMPENSATORIOS_300300017 = 300300017,
  PLANEJAMENTO_CONTEUDO_LECIONADO_MENU_300300015 = 300300015,
  CONFIGURARNOMECONTEUDOLECIONADO_MENU_300301300 = 300301300,
  NOMECONTEUDOLECIONADO_MENU_300301400 = 300301400,
  NOMECONTEUDOPLANJEADO_MENU_300301500 = 300301500,
  NOMEATIVIDADESCOMPLEMENTARESPROFESSOR_MENU_300301600 = 300301600,
  NOMEATIVIDADESCOMPLEMENTARESPROFESSOR_MENU_300301650 = 300301650,
  NOMEATIVIDADESCOMPLEMENTARESPROFESSOR_MENU_300302100 = 300302100,
  NOMEATIVIDADESCOMPLEMENTARESPROFESSOR_MENU_300302150 = 300302150,
  CONFIGURARNOMECONTEUDOLECIONADO_MENU_300301700 = 300301700,
  NOMECONTEUDOLECIONADO_MENU_300301800 = 300301800,
  NOMECONTEUDOLECIONADO_MENU_300301850 = 300301850,
  /**
   * "Permite Limpar Dias de Aula" — libera o botão Deletar Aulas do Conteúdo Lecionado.
   *
   * É permissão de AÇÃO, não de tela: quem chega ao Conteúdo Lecionado não necessariamente pode
   * apagar os dias de aula lançados. Antes a tela liberava o botão pelo NOME do grupo
   * (Coordenador/Supervisor), o que deixava de fora qualquer grupo novo por mais que o
   * administrador concedesse a permissão.
   */
  PERMITELIMPARDIASDEAULA_MENU_300301851 = 300301851,

  /**
   * "Permite Importar/Exportar Dias de Aula" — libera o botão Importar / Exportar do Conteúdo
   * Lecionado, que gera a planilha dos dias de aula e importa de volta o conteúdo digitado
   * nela (podendo criar dia de aula em data nova, com confirmação linha por linha).
   *
   * Permissão de AÇÃO, na mesma linha da 300301851: quem abre o Conteúdo Lecionado não
   * necessariamente pode gravar conteúdo em lote a partir de um arquivo externo. Lida por
   * `sessionService.PodeImportarExportarDiasDeAula()`.
   */
  PERMITEIMPORTAREXPORTARDIASAULA_MENU_300301852 = 300301852,

  /*
   * As três abaixo completam a barra de ações das aulas: cada botão do Conteúdo Lecionado
   * passa a ter a SUA permissão, em vez de todos irem juntos com o acesso à tela.
   *
   * ATENÇÃO OPERACIONAL: diferente de "Limpar" (851) e "Importar/Exportar" (852), que são
   * ações excepcionais, estas três são de uso DIÁRIO do professor. Como permissão só existe
   * quando concedida, a rede precisa liberá-las aos grupos ANTES do deploy — sem isso os três
   * botões desaparecem para todo mundo (o suporte continua vendo, por TemPermissao).
   */

  /** "Permite Copiar Dias de Aula" — botão Copiar Aulas. */
  PERMITECOPIARDIASAULA_MENU_300301853 = 300301853,

  /** "Permite Incluir Dias de Aula" — botão Incluir Aula. */
  PERMITEINCLUIRDIASAULA_MENU_300301854 = 300301854,

  /** "Permite Configurar Dias de Aula" — botão Configurar Aulas (gera os dias da etapa). */
  PERMITECONFIGURARDIASAULA_MENU_300301855 = 300301855,

  NOMECONTEUDOPLANJEADO_MENU_300301900 = 300301900,
  LANCAMENTODENOTASEFALTAS_MENU_300302200 = 300302200,
  LANCAMENTODENOTASEFALTAS_MENU_300302201 = 300302201,
  LANCAMENTODENOTASECHPET_MENU_300302300 = 300302300,
  DEFINIRFORMADELANCAMENTO_MENU_300302400 = 300302400,
  DEFINIRFORMADELANCAMENTO_MENU_300302401 = 300302401,
  NOTASEFALTASDISTRIBUICAO_MENU_300302500 = 300302500,
  NOTASECHPETDISTRIBUICAO_MENU_300302600 = 300302600,
  RECALCULODENOTAS_MENU_300303600 = 300303600,
  BLOQUEIODEDISCIPLINASPORETAPA_MENU_300303700 = 300303700,
  AULASLECIONADAS_MENU_300303800 = 300303800,
  AULASLECIONADASPORENSINO_MENU_300303900 = 300303900,
  EMITIRPENDENCIAS_MENU_300304200 = 300304200,
  EMITIRPENDENCIASANALITICOSINTETICO_MENU_300304300 = 300304300,
  RELATORIODESCRITIVA_MENU_300304600 = 300304600,
  RELATORIODESCRITIVO_MENU_300304601 = 300304601,
  RELATORIODESCRITIVOAVULSO_MENU_300304602 = 300304602,
  // Itens novos do menu da ficha descritiva (seg_menu reorganizado): um Relatório Descritivo, um
  // Relatório Descritivo Avulso, um Cadastro da Ficha e um Lançamento da Ficha. Substituem a
  // árvore antiga (300304600/601/602/700 e 3003048xx/3003049xx), que tinha nove itens para seis
  // páginas e duplicava tudo em "Ficha de Avaliação Multi".
  RELATORIODESCRITIVO_MENU_300304611 = 300304611,
  RELATORIODESCRITIVOAVULSO_MENU_300304612 = 300304612,
  RELATORIOSEMEAR_MENU_300304700 = 300304700,
  FICHADEAVALIACAO_MENU_300304800 = 300304800,
  CADASTRO_MENU_300304801 = 300304801,
  LEGENDAS_MENU_300304802 = 300304802,
  DISCIPLINAS_MENU_300304803 = 300304803,
  QUESTIONARIO_MENU_300304804 = 300304804,
  REPLICARFICHAPARAOUTRASESCOLAS_MENU_300304805 = 300304805,
  RELATORIOOBJETIVOSEMEAR_MENU_300304806 = 300304806,
  FICHADEAVALIACAO_MENU_300304807 = 300304807,
  CADASTROFICHA_MENU_300304810 = 300304810,
  LANCAMENTOFICHA_MENU_300304820 = 300304820,
  FICHADEAVALIACAOMULTI_MENU_300304900 = 300304900,
  CADASTROS_MENU_300304901 = 300304901,
  LEGENDAS_MENU_300304902 = 300304902,
  DISCIPLINAS_MENU_300304903 = 300304903,
  QUESTIONARIO_MENU_300304904 = 300304904,
  REPLICARFICHAPARAOUTRASESCOLAS_MENU_300304905 = 300304905,
  FICHADEAVALIACAO_MENU_300304906 = 300304906,
  LANCAMENTOFICHAACOMPANHAMENTO_MENU_300305000 = 300305000,
  AVALIACAOMULTIDIMENSIONAL_MENU_300305100 = 300305100,
  REGISTRODESCRITIVO_MENU_300305200 = 300305200,
  OBSERVACAOFICHAINDIVIDUALEATA_MENU_300305300 = 300305300,
  BOLETIM_MENU_300400100 = 300400100,
  BOLETIM_MENU_300400150 = 300400150,
  FICHADEACOMPANHAMENTO_MENU_300400200 = 300400200,
  FICHAINDIVIDUALINFANTIL_MENU_300400300 = 300400300,
  FICHAINDIVIDUAL_MENU_300400400 = 300400400,
  FICHAINDIVIDUAL_MENU_300400450 = 300400450,
  BOLETIMCOMNOTAPARCIAL_MENU_300400600 = 300400600,
  MEUSCURSOS_MENU_300500100 = 300500100,
  BOLETIMCOMNOTAPARCIAL_MENU_300500200 = 300500200,
  NOTAMISTA_MENU_300500400 = 300500400,
  BOLETIM_MENU_300500401 = 300500401,
  FICHAINDIVIDUALDENOTAMISTA_MENU_300500402 = 300500402,
  REEMISSAO_MENU_300500500 = 300500500,
  REEMISSAONOVO_MENU_300500599 = 300500599,
  FECHAMENTO_MENU_300600100 = 300600100,
  FECHAMENTOSEMESTRAL_MENU_300600101 = 300600101,
  FECHAMENTOANUAL_MENU_300600201 = 300600201,
  /**
   * Fechamento de Turmas (tela nova) — permissão PRÓPRIA, não reusa as do legado.
   *
   * Cobre as DUAS permissões antigas (300600101 Fechamento Semestral e 300600201 Fechamento
   * Anual), porque a tela nova unificou os dois recortes: o legado abria a mesma
   * `FecharTurma.aspx` duas vezes, por `?modoensino=`. Se a rede precisar separá-las de novo,
   * é uma permissão de AÇÃO para o filtro — não a volta das permissões antigas.
   *
   * Ver `saeweb-database-sql/consultebase/scripts/2026-09-02-Permissao-FechamentoTurmas.sql`.
   */
  FECHAMENTODETURMASNOVO_MENU_300600199 = 300600199,

  /**
   * Situações do Estudante (tela nova) — permissão PRÓPRIA, vizinha da legada 300901003
   * ("Situações do Estudante", `CadastrarSituacao.aspx`).
   *
   * Ver `saeweb-database-sql/consultebase/scripts/2026-09-02-Permissao-SituacoesEstudante.sql`.
   */
  SITUACOESDOESTUDANTENOVO_MENU_300901099 = 300901099,
  TURMAS_MENU_300600700 = 300600700,
  TURMAS_MENU_300600701 = 300600701,
  PERMITEMUDARDATAENTURMACAO_MENU_300600750 = 300600750,
  ENTURMACAOREGULAR_MENU_300600800 = 300600800,
  ENTURMACAO_MENU_300600801 = 300600801,

  ENTURMACAOPROGRESSAOPARCIAL_MENU_300600900 = 300600900,
  ENTURMACAOESPECIAL_MENU_300601000 = 300601000,
  ENTURMACAOLIVRE_MENU_300601100 = 300601100,
  ENTURMACAOAEE_MENU_300601200 = 300601200,
  CURSOLIVRE_MENU_300601300 = 300601300,
  CURSOLIVRE_MENU_300601301 = 300601301,
  ENTURMACAO_MENU_300601302 = 300601302,
  DISPENSA_MENU_300601400 = 300601400,
  CONSELHODECLASSE_MENU_300601450 = 300601450,
  CONSELHODECLASSE_MENU_300601451 = 300601451,
  HISTORICO_MENU_300700100 = 300700100,
  /** Tela NOVA do Histórico Escolar (Vue). Não reaproveita a 300700100 do legado. */
  HISTORICONOVO_MENU_300700199 = 300700199,
  CADASTRO_MENU_300700101 = 300700101,
  LEIS_MENU_300700102 = 300700102,
  /** Tela NOVA de Leis / Observações do histórico (Vue). Não reaproveita a 300700102. */
  LEISNOVO_MENU_300700197 = 300700197,
  DECLARACOES_MENU_300700200 = 300700200,
  DECLARACOESETERMOS_MENU_300700301 = 300700301,
  ESCOLARIDADESEDUC_MENU_300700303 = 300700303,
  CONCLUSAOSEDUC_MENU_300700304 = 300700304,
  TRANSFERENCIASEDUC_MENU_300700305 = 300700305,
  FREQUENCIASEDUC_MENU_300700306 = 300700306,
  CERTIFICADOCONCLUSAOEJA_MENU_300700400 = 300700400,
  ESCOLARIDADE_MENU_300700401 = 300700401,
  CONCLUSAO_MENU_300700402 = 300700402,
  TRANSFERENCIA_MENU_300700403 = 300700403,
  FREQUENCIA_MENU_300700404 = 300700404,
  DECLARACAODEMATRICULA_MENU_300700405 = 300700405,
  SEGUNDAVIATRANSFERENCIA_MENU_300700509 = 300700509,
  REQUERIMENTODETRANSFERENCIA_MENU_300700600 = 300700600,
  PERSONALIZADA_MENU_300700601 = 300700601,
  // Escolaridade
  DECLARACAOESCOLARIDADENOVO_MENU_300700411 = 300700411,
  DECLARACAOESCOLARIDADEPORTURMANOVO_MENU_300700412 = 300700412,

  // Conclusão
  DECLARACAOCONCLUSAONOVO_MENU_300700413 = 300700413,
  DECLARACAOCONCLUSAOPORTURMANOVO_MENU_300700414 = 300700414,

  // Transferência
  DECLARACAOTRANSFERENCIANOVO_MENU_300700415 = 300700415,

  // Frequência
  DECLARACAOFREQUENCIANOVO_MENU_300700416 = 300700416,
  ATESTADOFREQUENCIABOLSAFAMILIANOVO_MENU_300700417 = 300700417,

  // Transferência - Requerimento
  REQUERIMENTODETRANSFERENCIANOVO_MENU_300700418 = 300700418,

  // Vagas
  ATESTADODEVAGANOVO_MENU_300700419 = 300700419,
  NEGATIVADEVAGANOVO_MENU_300700420 = 300700420,
  // Declarações Personalizadas
  DECLARACAOPERSONALIZADANOVO_MENU_300700427 = 300700427,
  CADASTRODECLARACAOPERSONALIZADANOVO_MENU_300700428 = 300700428,

  // Vagas - Log
  LOGATESTADOSENEGATIVASDEVAGANOVO_MENU_300700429 = 300700429,
  DIPLOMAS_MENU_300700700 = 300700700,
  LIVRO_MENU_300700701 = 300700701,
  TIPOSDEENSINOPADRAO_MENU_300700800 = 300700800,
  ENSINOFUNDAMENTAL1ºAO5º_MENU_300700801 = 300700801,
  ENSINOFUNDAMENTAL6ºAO9º_MENU_300700802 = 300700802,
  ENSINOMEDIO_MENU_300700803 = 300700803,
  ENSINOMEDIONOVARESOLUCAOSEENº4657_MENU_300700804 = 300700804,
  ENSINOPROFISSIONALIZANTEMAGISTERIO_MENU_300700805 = 300700805,
  EJAANOSINICIAIS_MENU_300700806 = 300700806,
  EJAANOSFINAIS_MENU_300700807 = 300700807,
  EJAMEDIO_MENU_300700808 = 300700808,
  EDUCACAOINFANTIL_MENU_300700809 = 300700809,
  TIPOSDEENSINOPADRAO_MENUNOVO_300700810 = 300700810,
  PLANOSCURRICULARESDOHISTORICO_MENU_300700900 = 300700900,
  PLANOSCURRICULARESDOHISTORICO_MENUNOVO_300700901 = 300700901,
  DOCUMENTACAOINCOMPLETA_MENU_300800050 = 300800050,
  VISUALIZARQUADRODEHORARIO_MENU_300800100 = 300800100,
  PLANOSCURRICULARES_MENU_300800200 = 300800200,
  PORTURMA_MENU_CONFIGURACAO_300800300 = 300800300,
  RELATORIOCONDENSADOMODULOII_MENU_300800400 = 300800400,
  PENDENCIASCENSO_MENU_300800500 = 300800500,
  // [CENSO] Telas novas de Pendências do Censo.
  PENDENCIAS_CENSO_MI_NOVO_300800510 = 300800510,
  PENDENCIAS_CENSO_SF_NOVO_300800520 = 300800520,
  // [CENSO] Monitoramento de Pendências (painel da rede, 03/11/2026). Item na Seg_Menu a criar pelo Arthur.
  MONITORAMENTO_PENDENCIAS_CENSO_NOVO_300800530 = 300800530,
  ESTUDANTESDAESCOLA_MENU_300800600 = 300800600,
  ARQUIVAMENTO_MENU_300800700 = 300800700,
  TOTALDEESTUDANTESPORBAIRRO_MENU_300800800 = 300800800,
  TOTALDEESTUDANTESPORTURMA_MENU_300800900 = 300800900,
  TRANSPORTEDEESTUDANTES_MENU_300801000 = 300801000,
  ETIQUETAS_MENU_300801100 = 300801100,
  FUNCIONARIOS_MENU_300801200 = 300801200,
  ATIVOS_MENU_300801201 = 300801201,
  INATIVOS_MENU_300801202 = 300801202,
  MAGISTERIO_MENU_300801300 = 300801300,
  ATIVOS_MENU_300801301 = 300801301,
  INATIVOS_MENU_300801302 = 300801302,
  DOCENTES_MENU_300801400 = 300801400,
  ATIVOS_MENU_300801401 = 300801401,
  INATIVOS_MENU_300801402 = 300801402,
  RELATORIOALOCACAODEPROFESSORES_MENU_300801600 = 300801600,
  LIVRODEMATRICULA_MENU_300801700 = 300801700,
  EMITIRLIVRODEMATRICULAPORMODALIDADE_MENU_300801800 = 300801800,
  EMITIRLIVRODEMATRICULA_MENU_300801900 = 300801900,
  IDENTIDADE_MENU_300802100 = 300802100,
  PORESTUDANTE_MENU_300802101 = 300802101,
  PREVISAODEVAGAS_MENU_300802200 = 300802200,
  FICHADESAUDE_MENU_300802300 = 300802300,
  ALUNOSINFREQUENTES_MENU_300802400 = 300802400,
  FREQUENCIADOSESTUDANTES_MENU_300802500 = 300802500,
  PREVISAODEVAGASGERAL_MENU_300802600 = 300802600,
  ATAS_MENU_300802700 = 300802700,
  ATADEFECHAMENTOANUAL_MENU_300802701 = 300802701,
  ATADEFECHAMENTOANUAL_MENU_300802702 = 300802702,
  ATADEFECHAMENTOANUALENSINO_MENU_300802703 = 300802703,
  ATADEFECHAMENTOANUALSEDUC_MENU_300802704 = 300802704,
  ATADECONSELHODECLASSE_MENU_300802705 = 300802705,
  ATADEFECHAMENTOANUALNOVO_MENU_300802706 = 300802706,
  ATADECONSELHODECLASSENOVO_MENU_300802707 = 300802707,
  ESTATISTICAS_MENU_300802800 = 300802800,
  NOTASEFALTAS_MENU_300802900 = 300802900,
  NOTASEFREQUENCIASPENDENTES_MENU_300802901 = 300802901,
  NOTASEFALTASDOBIMESTRE_MENU_300802902 = 300802902,
  APROVEITAMENTOACUMULADO_MENU_300802903 = 300802903,
  FREQUENCIASCONFLITANTES_MENU_300802904 = 300802904,
  NOTASDIVERGENTES_MENU_300802905 = 300802905,
  ABAIXODAMEDIA_MENU_300802906 = 300802906,
  NOTASPARCIASTOTAIS_MENU_300802907 = 300802907,

  /*
   * EMISSÃO DE NOTAS E FALTAS — telas NOVAS (migração de EmitirNotasFaltas.aspx).
   *
   * Cada modelo tem a SUA permissão, e nunca a do item legado equivalente
   * (300802901-906): enquanto legado e sistema novo convivem, a rede precisa liberar um
   * sem o outro — piloto na tela nova sem mexer em quem usa a antiga, ou desativar a
   * antiga sem derrubar a nova. Ver CLAUDE.md, "Permissão de tela nova".
   *
   * A ORDEM não é a dos modelos: são os números que a rede já cadastrou na Seg_Menu
   * (909-914), e o primeiro modelo ficou com o 914 porque 907 e 908 já eram de Notas
   * Parciais e Totais. Não renumere para "arrumar" a sequência — os itens existem em
   * produção, e trocar o número aqui desliga a permissão de quem já a recebeu.
   */
  NOTASEFREQUENCIASPENDENTESNOVO_MENU_300802914 = 300802914,
  NOTASEFALTASDOBIMESTRENOVO_MENU_300802909 = 300802909,
  APROVEITAMENTOACUMULADONOVO_MENU_300802910 = 300802910,
  FREQUENCIASCONFLITANTESNOVO_MENU_300802911 = 300802911,
  NOTASDIVERGENTESNOVO_MENU_300802912 = 300802912,
  ABAIXODAMEDIANOVO_MENU_300802913 = 300802913,
  NOTASECHPET_MENU_300803000 = 300803000,
  NOTASECHPORPERIODOS_MENU_300803001 = 300803001,
  APROVEITAMENTOACUMULADOPORPERIODOS_MENU_300803002 = 300803002,
  GRAFICOS_MENU_300803100 = 300803100,
  APROVEITAMENTOPORTURMA_MENU_300803101 = 300803101,
  DIARIO_MENU_300803200 = 300803200,
  EMISSAODETALETASDOPROFESSOR_MENU_300803300 = 300803300,
  EMISSAODETALETASDOPROFESSOR_MENU_300803400 = 300803400,
  EMISSAODEDIARIOELETRONICO_MENU_300803401 = 300803401,
  EMISSAODEDIARIOSEDUC_MENU_300803500 = 300803500,
  EMISSAODEDIARIO_MENU_300803600 = 300803600,
  EMISSAODEDIARIOELETRONICO_MENU_300803601 = 300803601,
  GERADORDERELATORIOS_MENU_300803700 = 300803700,
  ESTUDANTES_MENU_300803701 = 300803701,
  FUNCIONARIOS_MENU_300803702 = 300803702,
  ESTUDANTESNOVO_MENU_300803799 = 300803799,
  FUNCIONARIOSNOVO_MENU_300803798 = 300803798,
  MALADIRETA_MENU_300803800 = 300803800,
  FOLHADEPONTO_MENU_300803900 = 300803900,
  CIRCULARES_MENU_300804000 = 300804000,
  DISCIPLINASTURMAS_MENU_300805000 = 300805000,
  DISCIPLINASTURMASNOVO_MENU_300805099 = 300805099,
  DOCUMENTOS_MENU_300900050 = 300900050,
  ORIGEM_MENU_300900051 = 300900051,
  SALASEAMBIENTES_MENU_300900100 = 300900100,
  SALASEAMBIENTESNOVO_MENU_300900101 = 300900101,
  SALASEAMBIENTES_MENU_300900102 = 300900102,
  FUNCAOORIGINALDASALA_MENU_300900103 = 300900103,
  UTILIZACAODASALA_MENU_300900104 = 300900104,
  PLANOSCURRICULARES_MENU_300900200 = 300900200,
  TIPODEENSINO_MENU_300900300 = 300900300,
  CONTEUDOSCURRICULARES_MENU_300900400 = 300900400,
  TIPODEENSINONOVO_MENU_300900301 = 300900301,
  PLANOSCURRICULARES_MENUNOVO_300900201 = 300900201,
  TURNOS_MENU_300900500 = 300900500,
  NOVO_TURNOS_MENU_300900501 = 300900501,
  INFORMACOESCOMPLEMENTARES_MENU_300900600 = 300900600,
  ESTRUTURAINFORMACOESCOMPLEMENTARES_MENU_300900601 = 300900601,
  SERIEINFORMACOESCOMPLEMENTARES_MENU_300900602 = 300900602,
  INFORMACOESPERIODICA_MENU_300900700 = 300900700,
  ESTRUTURAINFORMACOESPERIODICAS_MENU_300900800 = 300900800,
  SERIEINFORMACOESPERIODICAS_MENU_300900900 = 300900900,
  /**
   * Estrutura das Informações Complementares/Periódicas na tela NOVA (a do PDI - Estrutura,
   * parametrizada pelo tipo de estrutura). Uma permissão cobre a estrutura E as escalas, que no
   * legado eram dois menus (601/602 e 800/900) — na tela nova são abas da mesma tela.
   */
  ESTRUTURAINFORMACOESCOMPLEMENTARESNOVO_MENU_300900699 = 300900699,
  ESTRUTURAINFORMACOESPERIODICASNOVO_MENU_300900899 = 300900899,
  TABELAS_MENU_300901000 = 300901000,
  TIPODERESPONSAVEL_MENU_300901001 = 300901001,
  TIPODERENOVACAO_MENU_300901002 = 300901002,
  SITUACOESDOESTUDANTE_MENU_300901003 = 300901003,
  TRANSPORTEESCOLAR_MENU_300901004 = 300901004,
  BAIRROS_MENU_300901005 = 300901005,
  CIDADES_MENU_300901006 = 300901006,
  PROFISSOES_MENU_300901007 = 300901007,
  RELIGIOES_MENU_300901008 = 300901008,
  TIPOLOGRADOUROS_MENU_300901009 = 300901009,
  TIPOOCORRENCIAS_MENU_300901010 = 300901010,
  LOGRADOUROS_MENU_300901011 = 300901011,
  REGIOES_MENU_300901012 = 300901012,
  MOTIVOS_MENU_300901013 = 300901013,
  PETETAPAS_MENU_300901014 = 300901014,
  CARGOS_MENU_300901015 = 300901015,
  FUNDAMENTACOESLEGAIS_MENU_300901016 = 300901016,
  DECLARACOESPERSONALIZADAS_MENU_300901017 = 300901017,

  /**
   * Acadêmico → Parâmetros → Tabelas (telas novas) — permissões PRÓPRIAS. Os vizinhos "...99"
   * já eram da Situação do Estudante (300901099), então estas ocupam a faixa livre mais próxima
   * dos itens legados (300901018 em diante, na ordem do menu legado).
   *
   * Ver `saeweb-database-sql/consultebase/scripts/2026-11-05-Permissoes-TabelasAuxiliares.sql` e
   * `docs/tabelas-auxiliares/`.
   */
  TIPODERESPONSAVELNOVO_MENU_300901018 = 300901018,
  TIPODERENOVACAONOVO_MENU_300901019 = 300901019,
  TRANSPORTEESCOLARNOVO_MENU_300901020 = 300901020,
  BAIRROSNOVO_MENU_300901021 = 300901021,
  CIDADESNOVO_MENU_300901022 = 300901022,
  PROFISSOESNOVO_MENU_300901023 = 300901023,
  RELIGIOESNOVO_MENU_300901024 = 300901024,
  TIPOLOGRADOUROSNOVO_MENU_300901025 = 300901025,
  LOGRADOUROSNOVO_MENU_300901026 = 300901026,
  REGIOESNOVO_MENU_300901027 = 300901027,
  MOTIVOSNOVO_MENU_300901028 = 300901028,
  PETETAPASNOVO_MENU_300901029 = 300901029,
  CARGOSNOVO_MENU_300901030 = 300901030,
  FUNDAMENTACOESLEGAISNOVO_MENU_300901031 = 300901031,
  VINCULACAODECARGO_MENU_301000100 = 301000100,
  ALOCACAOTEMPORARIA_MENU_301000200 = 301000200,
  CADASTRODEFUNCIONARIOS_MENU_301000300 = 301000300,
  CADASTRODEFUNCIONARIOSNOVO_MENU_301000399 = 301000399,
  ORIENTADORPEDAGOGO_MENU_301000400 = 301000400,
  ALOCACAODEPROFESSORES_MENU_301000500 = 301000500,
  ALOCACAODEPROFESSORES_MENU_301000501 = 301000501,
  PROFESSORREFERENCIA_MENU_301000600 = 301000600,
  QUADRODATURMA_MENU_301000700 = 301000700,
  QUADRODOPROFESSOR_MENU_301000800 = 301000800,
  QUADRODATURMA_MENU_301000701 = 301000701,
  QUADRODOPROFESSOR_MENU_301000801 = 301000801,
  LIMPARQUADRODEHORARIO_MENU_301000900 = 301000900,
  VISUALIZARQUADRODEHORARIO_MENU_301001000 = 301001000,
  RELATORIOALOCACAODEPROFESSORES_MENU_301001100 = 301001100,
  OCORRENCIAS_MENU_301001200 = 301001200,
  CONTROLEDEFALTAS_MENU_301001300 = 301001300,
  REGISTRODEFALTAS_MENU_301001400 = 301001400,
  EMISSAODEFALTAS_MENU_301001500 = 301001500,
  TAREFAS_MENU_301100100 = 301100100,
  HISTORICOAUTOMATICO_MENU_301100200 = 301100200,
  VISUALIZARPAGAMENTOS_MENU_301200100 = 301200100,
  FICHASDECONSELHOTUTELAR_MENU_301300100 = 301300100,
  FICHASDECONSELHOTUTELARNOVO_MENU_301300199 = 301300199,
  CADASTRO_MENU_301400100 = 301400100,
  CADASTRO_AVISOSENOTIFICACOES_MENU_301400150 = 301400150,
  QUESTIONARIORESPONSAVEL_MENU_301400200 = 301400200,
  MURAL_MENU_301400300 = 301400300,
  RESPONDERQUESTIONARIO_MENU_301400400 = 301400400,
  TUTORIAIS_MENU_309000000 = 309000000,
  DADOSALUNOPDIPADRAO_MENU_390000060 = 390000060,
  EDITARPDINUM4256PROFESSOR_MENU_390000065 = 390000065,
  EDITARPDINUM4256SUPERVISAO_MENU_390000066 = 390000066,
  NOVO_PDI_RES_4256_MENU_390000070 = 390000070,
  VISUALIZARPDINUM4256PROFESSOR_MENU_390000106 = 390000106,
  VISUALIZARPDINUM4256SUPERVISAO_MENU_390000107 = 390000107,
  ACESSARMENUALUNO_MENU_690000001 = 690000001,
  SISTEMADIARIOELETRONICO_MENU_690000002 = 690000002,
  ACESSARMENUALUNO_MENU_790000001 = 790000001,
  BOLETIM_MENU_790000002 = 790000002,
  SISTEMAPORTALDOESTUDANTE_MENU_790000003 = 790000003,
  GRUPOSPERMISSOES_MENU_900100100 = 900100100,
  USUARIOSGRUPOS_MENU_900100200 = 900100200,
  RELATORIODEUSUARIOSEGRUPOS_MENU_900200100 = 900200100,
  ACESSARLOGDEREGISTROS_MENU_990000001 = 990000001,
  ACESSARMENUGESTAO_MENU_990000002 = 990000002,
  ACESSARMENUUSUARIOS_MENU_990000003 = 990000003,
  ALTERAR_MENU_990000004 = 990000004,
  CADASTRARGRUPOSDEUSUARIOS_MENU_990000005 = 990000005,
  CADASTRARUSUARIOS_MENU_990000006 = 990000006,
  CONSULTAR_MENU_990000007 = 990000007,
  EXCLUIR_MENU_990000008 = 990000008,
  INCLUIR_MENU_990000009 = 990000009,
  SISTEMAGESTAODEUSUARIOS_MENU_990000010 = 990000010,
  TROCARSENHADOUSUARIOLOGADO_MENU_990000011 = 990000011,
  VISUALIZARCONTEÚDODOBACKUP_MENU_990000012 = 990000012,
  ALIMENTOS_MENU_1000100100 = 1000100100,
  NECESSIDADEDIARIA_MENU_1000200100 = 1000200100,
  TIPODEREFEICAO_MENU_1000200200 = 1000200200,
  CARDAPIO_MENU_1000200300 = 1000200300,
  PREPARACAO_MENU_1000200400 = 1000200400,
  CARDAPIOPADRAO_MENU_1000200500 = 1000200500,
  CALENDARIOCARDAPIO_MENU_1000200600 = 1000200600,
  COMENSAISPORESCOLA_MENU_1000200700 = 1000200700,
  REFEICOESSERVIDAS_MENU_1000200800 = 1000200800,
  COMPOSICAODEPREPARACAO_MENU_1000200900 = 1000200900,
  BALANCEAMENTOPREPARACAO_MENU_1000201000 = 1000201000,
  BALANCEAMENTOMENSALCARDAPIO_MENU_1000201100 = 1000201100,
  RELATORIOCARDAPIODOMES_MENU_1000201200 = 1000201200,
  INCIDENCIASDEPREPARACAO_MENU_1000201300 = 1000201300,
  RELATORIODEREFEICOESSERVIDAS_MENU_1000201400 = 1000201400,
  RELATORIODEREFEICOESCONSOLIDADAS_MENU_1000201500 = 1000201500,
  REPETICAOACEITACAODEREFEICOES_MENU_1000201600 = 1000201600,
  OCORRENCIASNASREFEICOES_MENU_1000201700 = 1000201700,

  /**
   * Seção "Cardápio" nas Homes do estudante e do responsável — exigência do edital.
   *
   * Separada das permissões de CADASTRO do cardápio (1000200300 e vizinhas) de propósito:
   * quem monta o cardápio é a nutricionista da rede, quem lê no portal é a família. Uma
   * permissão só faria liberar a leitura no portal implicar liberar a edição do cardápio.
   */
  CARDAPIOPORTAL_MENU_1000201800 = 1000201800,
  PADRAOESTOQUE_MENU_1000300100 = 1000300100,
  CENTRODEDISTRIBUICAO_MENU_1000300200 = 1000300200,
  PARÂMETROESCOLA_MENU_1000300300 = 1000300300,
  MOVIMENTACAO_MENU_1000300400 = 1000300400,
  LEVANTAMENTODEESTOQUE_MENU_1000300500 = 1000300500,
  ACOMPANHAMENTODEESTOQUE_MENU_1000300600 = 1000300600,
  CONTROLEDEESTOQUE_MENU_1000300700 = 1000300700,
  RELATORIODEMOVIMENTACAODEESTOQUE_MENU_1000300800 = 1000300800,
  REPOSICAOPORCARDAPIO_MENU_1000400100 = 1000400100,
  SOLICITACAOPARAREPOSICAO_MENU_1000400200 = 1000400200,
  FORNECIMENTODEMATERIAL_MENU_1000400300 = 1000400300,
  ENTREGA_MENU_1000400400 = 1000400400,
  TIPOFORNECIMENTO_MENU_1000500100 = 1000500100,
  FORNECEDOR_MENU_1000500200 = 1000500200,
  CONTRATO_MENU_1000500300 = 1000500300,
  MEDICAO_MENU_1000500400 = 1000500400,
  SALDOCONTRATUAL_MENU_1000500500 = 1000500500,
  MEDICAOIMC_MENU_1000600050 = 1000600050,
  TIPODEMATERIAIS_MENU_1000600100 = 1000600100,
  ITENSDEBALANCEAMENTO_MENU_1000600200 = 1000600200,
  UNIDADEDEMEDIDA_MENU_1000600300 = 1000600300,
  EMBALAGEM_MENU_1000600400 = 1000600400,
  DIETAESPECIAL_MENU_1000600500 = 1000600500,
  PARÂMETROSALIMENTACAO_MENU_1000600600 = 1000600600,
  ROTA_MENU_1000600700 = 1000600700,
  CARDAPIO_MENU_1090000001 = 1090000001,
  ENTREGADEMATERIAIS_MENU_1090000002 = 1090000002,
  FORNECEDOR_MENU_1090000003 = 1090000003,
  FORNECIMENTODEMATERIAIS_MENU_1090000004 = 1090000004,
  LANCAMENTOSCENTRODISTRIBUICAO_MENU_1090000005 = 1090000005,
  LANCAMENTOSESCOLA_MENU_1090000006 = 1090000006,
  PARÂMETROSALIMENTOSESCOLA_MENU_1090000007 = 1090000007,
  PARÂMETROSALIMENTOSGERAL_MENU_1090000008 = 1090000008,
  PARÂMETROSESTOQUEESCOLA_MENU_1090000009 = 1090000009,
  PARÂMETROSESTOQUEGERAL_MENU_1090000010 = 1090000010,
  REFEICOESSERVIDAS_MENU_1090000011 = 1090000011,
  RELATORIOSALIMENTACAO_MENU_1090000012 = 1090000012,
  RELATORIOSDEESTOQUE_MENU_1090000013 = 1090000013,
  RELATORIOSMEDICAO_MENU_1090000014 = 1090000014,
  SISTEMAALIMENTACAO_MENU_1090000015 = 1090000015,
  SOLICITACAOPARAREPOSICAO_MENU_1090000016 = 1090000016,
  SOLICITACAOEPASSE_MENU_1100100100 = 1100100100,
  SOLICITACAOEPASSENOVO_MENU_1100100199 = 1100100199,
  SOLICITACAOEPASSETURMANOVO_MENU_1100100198 = 1100100198,
  ASSOCIACAOAUTOMATICADEROTAS_MENU_1100100200 = 1100100200,
  ROTASPARAALUNOS_MENU_1100100300 = 1100100300,
  ENTREGADEPASSEESCOLAR_MENU_1100100400 = 1100100400,
  DISTÂNCIADAESCOLA_MENU_1100100500 = 1100100500,
  RELATORIOALUNOS_MENU_1100100600 = 1100100600,
  QUADRORESUMO_MENU_1100100700 = 1100100700,
  QUADRORESUMONOVO_MENU_1100100799 = 1100100799,

  /**
   * Seção "Transporte" nas Homes do estudante e do responsável — exigência do edital.
   *
   * Mostra apenas o que diz respeito ÀQUELE estudante (situação, rota, ponto, horários e
   * prestador). Não se confunde com as telas de gestão da frota, que continuam com as suas
   * permissões próprias.
   */
  TRANSPORTEPORTAL_MENU_1100100800 = 1100100800,
  VIAGEM_MENU_1100200100 = 1100200100,
  VEICULOS_MENU_1100200200 = 1100200200,
  ROTAS_MENU_1100200300 = 1100200300,
  ROTASNOVO_MENU_1100200399 = 1100200399,
  CUSTOVEICULO_MENU_1100200400 = 1100200400,
  RELATORIODEVEICULOS_MENU_1100200500 = 1100200500,
  RELATORIODEVEICULOSNOVO_MENU_1100200599 = 1100200599,
  ROTAS_MENU_1100200600 = 1100200600,
  MAPADEVIAGENSNOVO_MENU_1100200699 = 1100200699,
  CUSTOROTA_MENU_1100200700 = 1100200700,
  EMISSAODEPASSES_MENU_1100200800 = 1100200800,
  EMISSAODEPASSESNOVO_MENU_1100200801 = 1100200801,
  PORESTUDANTE_MENU_1100200850 = 1100200850,
  PASSAGEMALUNONOVO_MENU_1100200899 = 1100200899,
  INSPECAOVEICULOS_MENU_1100300100 = 1100300100,
  INSPECAOMOTORISTA_MENU_1100300200 = 1100300200,
  FICHADEINSPECAO_MENU_1100300300 = 1100300300,
  INSPECOESPENDENTES_MENU_1100300400 = 1100300400,
  PARÂMETROSTRANSPORTE_MENU_1100400100 = 1100400100,
  USUARIOSEXTERNOSDOTRANSPORTE_MENU_1100400200 = 1100400200,
  SERVIDORES_MENU_1100400300 = 1100400300,
  SERVIDORESTRANSPORTENOVO_MENU_1100400399 = 1100400399,
  FORNECEDORDETRANSPORTE_MENU_1100400400 = 1100400400,
  ESTRUTURAINSPECAOVEICULO_MENU_1100400500 = 1100400500,
  ESTRUTURAINSPECAOTRANSPORTENOVO_MENU_1100400599 = 1100400599,
  SERIEINSPECAOVEICULO_MENU_1100400600 = 1100400600,
  ASSINATURAINSPECAOVEICULO_MENU_1100400601 = 1100400601,
  ESTRUTURAINSPECAOMOTORISTA_MENU_1100400700 = 1100400700,
  SERIEINSPECAOMOTORISTA_MENU_1100400800 = 1100400800,
  ASSINATURAINSPECAOMOTORISTA_MENU_1100400801 = 1100400801,
  INTEGRACAOSETENOVO_MENU_1100400999 = 1100400999,
  INFORMACOESDOSALUNOS_MENU_1190000001 = 1190000001,
  INSPECAODEVEICULOEPESSOAL_MENU_1190000002 = 1190000002,
  PARÂMETROSDETRANSPORTE_MENU_1190000003 = 1190000003,
  RELATORIOSDETRANSPORTE_MENU_1190000004 = 1190000004,
  SISTEMATRANSPORTE_MENU_1190000005 = 1190000005,
  VEICULOSEROTAS_MENU_1190000006 = 1190000006,
  BEM_MENU_1200100100 = 1200100100,
  ALOCACAODETIPODEBENS_MENU_1200200100 = 1200200100,
  PLANEJAMENTOPATRIMONIAL_MENU_1200200200 = 1200200200,
  ENCERRAMENTODEINVENTARIO_MENU_1200200300 = 1200200300,
  LISTADEINVENTARIO_MENU_1200300100 = 1200300100,
  ESTADODECONSERVACAO_MENU_1200300200 = 1200300200,
  FORMADETOMBAMENTO_MENU_1200300300 = 1200300300,
  MOTIVODEBAIXA_MENU_1200300400 = 1200300400,
  RESPONSAVELPATRIMONIO_MENU_1200300500 = 1200300500,
  RELATORIOPATRIMONIO_MENU_1200400100 = 1200400100,
  RELATORIOBAIXAS_MENU_1200400200 = 1200400200,
  BEM_MENU_1290000001 = 1290000001,
  LISTADEINVENTARIO_MENU_1290000002 = 1290000002,
  RELATORIOBAIXAS_MENU_1290000003 = 1290000003,
  RELATORIOPATRIMONIO_MENU_1290000004 = 1290000004,
  SISTEMAPATRIMONIO_MENU_1290000005 = 1290000005,

  //Biblioteca
  BIB_CATALOGACAO_MENU_1300100100 = 1300100100,
  BIB_EXEMPLARESCOLA_MENU_1300100200 = 1300100200,
  BIB_EXEMPLARCENTRAL_MENU_1300100300 = 1300100300,
  BIB_MATERIALCARTOGRAFICO_MENU_1300100400 = 1300100400,
  BIB_MATERIALGRAFICO_MENU_1300100500 = 1300100500,
  BIB_FILMES_MENU_1300100600 = 1300100600,
  BIB_DISCOSCDEDVD_MENU_1300100700 = 1300100700,
  BIB_FOTOS_MENU_1300100800 = 1300100800,
  BIB_CADASTROPALAVRACHAVE_MENU_1300200100 = 1300200100,
  BIB_PESQUISAPALAVRACHAVE_MENU_1300200200 = 1300200200,
  BIB_PARAMETROSUSUARIOS_MENU_1300300100 = 1300300100,
  BIB_AREADEINTERESSE_MENU_1300300200 = 1300300200,
  BIB_BLOQUEIODESBLOQUEIO_MENU_1300300300 = 1300300300,
  BIB_CONTROLEBLOQUEIO_MENU_1300300400 = 1300300400,
  BIB_RELATORIODEUSUARIOSEGRUPOS_MENU_1300300500 = 1300300500,
  BIB_RESERVAESCOLA_MENU_1300400100 = 1300400100,
  BIB_RESERVACENTRAL_MENU_1300400150 = 1300400150,
  BIB_CONTROLERESERVA_MENU_1300400200 = 1300400200,
  BIB_EMPRESTIMOESCOLA_MENU_1300400300 = 1300400300,
  BIB_EMPRESTIMOCENTRAL_MENU_1300400350 = 1300400350,
  BIB_RENOVACAOESCOLA_MENU_1300400400 = 1300400400,
  BIB_RENOVACAOCENTRAL_MENU_1300400450 = 1300400450,
  BIB_RELATORIODEEMPRESTIMOPORALUNO_MENU_1300400460 = 1300400460,
  BIB_RELATORIODERENOVACOESPORALUNO_MENU_1300400470 = 1300400470,
  BIB_CONTROLEEMPRESTIMORESERVAESCOLA_MENU_1300400500 = 1300400500,
  BIB_CONTROLEEMPRESTIMORESERVACENTRAL_MENU_1300400600 = 1300400600,
  BIB_CARTEIRINHAS_MENU_1300500050 = 1300500050,
  BIB_ETIQUETA_MENU_1300500100 = 1300500100,
  BIB_IMPORTACAODEACERVO_MENU_1300500200 = 1300500200,
  BIB_ACERVO_MENU_1300600200 = 1300600200,
  BIB_AQUISICOESNOPERIODO_MENU_1300600300 = 1300600300,
  BIB_EXEMPLARESPORLOCALIZACAO_MENU_1300600400 = 1300600400,
  BIB_BAIXADEEXEMPLARES_MENU_1300600500 = 1300600500,
  BIB_MULTAS_MENU_1300600600 = 1300600600,
  BIB_ESTATISTICA_MENU_1300600700 = 1300600700,
  BIB_OBRASMAISEMPRESTADAS_MENU_1300600800 = 1300600800,
  BIB_GRAFICOS_MENU_1300600900 = 1300600900,
  BIB_ACERVO_MENU_1300700200 = 1300700200,
  BIB_AQUISICOESNOPERIODO_MENU_1300700300 = 1300700300,
  BIB_EXEMPLARESPORLOCALIZACAO_MENU_1300700400 = 1300700400,
  BIB_BAIXADEEXEMPLARES_MENU_1300700500 = 1300700500,
  BIB_MULTAS_MENU_1300700600 = 1300700600,
  BIB_ESTATISTICA_MENU_1300700700 = 1300700700,
  BIB_OBRASMAISEMPRESTADAS_MENU_1300700800 = 1300700800,
  BIB_GRAFICOS_MENU_1300700900 = 1300700900,
  BIB_TIPODEDOCUMENTO_MENU_1300800100 = 1300800100,
  BIB_TIPOSDEMIDIA_MENU_1300800200 = 1300800200,
  BIB_CLASSIFICACAODEOBRAS_MENU_1300800300 = 1300800300,
  BIB_CLASSIFICACAOPORCOR_MENU_1300800400 = 1300800400,
  BIB_AUTOR_MENU_1300800500 = 1300800500,
  BIB_ENTIDADE_MENU_1300800600 = 1300800600,
  BIB_EDITORA_MENU_1300800700 = 1300800700,
  BIB_LOCALDEPUBLICACAO_MENU_1300800800 = 1300800800,
  BIB_EVENTO_MENU_1300800900 = 1300800900,
  BIB_FORMASDEAQUISICAO_MENU_1300801000 = 1300801000,
  BIB_MOEDA_MENU_1300801100 = 1300801100,
  BIB_MOTIVODADISPENSADEMULTA_MENU_1300801200 = 1300801200,
  BIB_MOTIVOBAIXA_MENU_1300801300 = 1300801300,
  BIB_MOTIVOBLOQUEIOUSUARIO_MENU_1300801400 = 1300801400,
  BIB_LOCALIZACAOFISICAOBRASESCOLA_MENU_1300801500 = 1300801500,
  BIB_LOCALIZACAOFISICAOBRASCENTRAL_MENU_1300801550 = 1300801550,
  BIB_IDIOMAS_MENU_1300801600 = 1300801600,
  BIB_AREADEINTERESSE_MENU_1300801700 = 1300801700,
  BIB_AREADECONHECIMENTO_MENU_1300801800 = 1300801800,
  BIB_CONFIGURACAOBIBLIOTECA_MENU_1300801900 = 1300801900,
  BIB_IMPORTACAODEACERVO_MENU_1300802100 = 1300802100,
  BIB_RELATORIO_ACERVO_BIBLIOTECA_MENU_1300802201 = 1300600201,

  //Fim Biblioteca
  SERVIDOR_MENU_1400100100 = 1400100100,
  INFORMACOESCURRICULARES_MENU_1400100200 = 1400100200,
  UNIFORME_MENU_1400100300 = 1400100300,
  BENEFICIOS_MENU_1400100400 = 1400100400,
  OCORRENCIAS_MENU_1400100500 = 1400100500,
  RELATORIOOCORRENCIA_MENU_1400100510 = 1400100510,
  HISTORICOFUNCIONAL_MENU_1400200100 = 1400200100,
  CONTAGEMDETEMPO_MENU_1400200200 = 1400200200,
  FERIAS_MENU_1400300100 = 1400300100,
  ACOMPANHAMENTOFERIAS_MENU_1400300200 = 1400300200,
  APURACAODEFREQUENCIA_MENU_1400300300 = 1400300300,
  APURACAODEFREQUENCIA_MENU_1400300400 = 1400300400,
  CONFERENCIADEFREQUENCIA_MENU_1400300500 = 1400300500,
  FREQUENCIAMENSAL_MENU_1400300600 = 1400300600,
  RELATORIODEFREQUENCIA_MENU_1400300700 = 1400300700,
  QUADROINFORMATIVO_MENU_1400300800 = 1400300800,
  FUNCOES_MENU_1400400100 = 1400400100,
  VAGASNAESCOLAPADMINISTRATIVOMAGISTERIO_MENU_1400400200 = 1400400200,
  ALOCACAOPESSOALADMINISTRATIVOMAGISTERIO_MENU_1400400300 = 1400400300,
  ACOMPANHAMENTODEVAGASDOCENCIA_MENU_1400400400 = 1400400400,
  ACOMPANHAMENTODEADMINISTRATIVOMAGISTERIO_MENU_1400400500 = 1400400500,
  VAGASDEESTAGIO_MENU_1400500100 = 1400500100,
  ESTAGIO_MENU_1400500200 = 1400500200,
  DISCIPLINASDEESTAGIO_MENU_1400500300 = 1400500300,
  INSTITUICOESCONVENIADAS_MENU_1400500400 = 1400500400,
  CONTROLEDEESTAGIO_MENU_1400500500 = 1400500500,
  VAGASDEESTAGIO_MENU_1400500600 = 1400500600,
  RELACAODEPESSOAL_MENU_1400600100 = 1400600100,
  CARGAHORARIASEMANAL_MENU_1400600200 = 1400600200,
  CONTAGEMDETEMPO_MENU_1400600300 = 1400600300,
  FICHAPESSOALPARAPREENCHIMENTO_MENU_1400600400 = 1400600400,
  FICHAFUNCIONAL_MENU_1400600500 = 1400600500,
  MEMORIADECALCULO_MENU_1400600600 = 1400600600,
  ACOMPANHAMENTODEENTREGAUNIFORME_MENU_1400600700 = 1400600700,
  ESTRUTURAORGANIZACIONAL_MENU_1400700100 = 1400700100,
  TIPODEOCORRENCIA_MENU_1400700150 = 1400700150,
  PARÂMETROAPURACAOFREQUENCIA_MENU_1400700200 = 1400700200,
  RESPONSAVELRH_MENU_1400700300 = 1400700300,
  FORNECEDORDEMAODEOBRA_MENU_1400700400 = 1400700400,
  QUADRO_MENU_1400700500 = 1400700500,
  VINCULOEMPREGATICIO_MENU_1400700600 = 1400700600,
  CARGOSEFUNCOES_MENU_1400700700 = 1400700700,
  CARGOCOMISSIONADO_MENU_1400700800 = 1400700800,
  BENEFICIOS_MENU_1400700900 = 1400700900,
  TIPODEMOVIMENTACAO_MENU_1400701000 = 1400701000,
  TIPODEDESLIGAMENTO_MENU_1400701100 = 1400701100,
  LICENCAS_MENU_1400701200 = 1400701200,
  PROVIMENTO_MENU_1400701300 = 1400701300,
  AREADEFORMACAO_MENU_1400800100 = 1400800100,
  TIPODETITULACAO_MENU_1400800200 = 1400800200,
  TITULACAO_MENU_1400800300 = 1400800300,
  IDIOMA_MENU_1400800400 = 1400800400,
  TIPODECURSO_MENU_1400800500 = 1400800500,
  TIPODECONCURSO_MENU_1400800600 = 1400800600,
  CONCURSO_MENU_1400800700 = 1400800700,
  IES_MENU_1400800800 = 1400800800,
  ACESSATODOSOSSERVIDORES_MENU_1490000001 = 1490000001,
  CADASTROBENEFICIOSDOSERVIDOR_MENU_1490000002 = 1490000002,
  CADASTRODEBENEFICIOS_MENU_1490000003 = 1490000003,
  CADASTROSERVIDOR_MENU_1490000004 = 1490000004,
  CONFERENCIAFREQUENCIA_MENU_1490000005 = 1490000005,
  EMISSAOFOLHADEPONTO_MENU_1490000006 = 1490000006,
  LANCAMENTODEAFASTAMENTOS_MENU_1490000007 = 1490000007,
  LANCAMENTODEHISTORICOFUNCIONAL_MENU_1490000008 = 1490000008,
  LANCAMENTOFREQUENCIA_MENU_1490000009 = 1490000009,
  LANCAMENTOSDEESTAGIO_MENU_1490000010 = 1490000010,
  LANCAMENTOSEMFUNCAO_MENU_1490000011 = 1490000011,
  MENUCADASTRO_MENU_1490000012 = 1490000012,
  MENUESTAGIO_MENU_1490000013 = 1490000013,
  MENUFREQUENCIA_MENU_1490000014 = 1490000014,
  MENUFUNCAO_MENU_1490000015 = 1490000015,
  MENUHISTORICOFUNCIONAL_MENU_1490000016 = 1490000016,
  MENURELATORIOS_MENU_1490000017 = 1490000017,
  MENUSERVIDOR_MENU_1490000018 = 1490000018,
  OCORRENCIASSERVIDOR_MENU_1490000019 = 1490000019,
  RELATORIOSDEESTAGIO_MENU_1490000020 = 1490000020,
  RELATORIOSDEFUNCAO_MENU_1490000021 = 1490000021,
  RELATORIOSDEHISTORICOFUNCIONAL_MENU_1490000022 = 1490000022,
  RELATORIOSFREQUENCIA_MENU_1490000023 = 1490000023,
  SISTEMAPESSOAL_MENU_1490000024 = 1490000024,
  CONVENIOPROJETOS_MENU_1500100100 = 1500100100,
  DESEMBOLSO_MENU_1500100200 = 1500100200,
  CONCILIACAOBANCARIA_MENU_1500100300 = 1500100300,
  PRESTACAODECONTAS_MENU_1500100400 = 1500100400,
  MEMORIADECALCULO_MENU_1500100500 = 1500100500,
  ACOMPANHAMENTOESCOLA_MENU_1500100600 = 1500100600,
  DILIGENCIAS_MENU_1500200100 = 1500200100,
  FISCALIZACAOPENDENTE_MENU_1500200200 = 1500200200,
  QUADROPROJETOSCONVENIOS_MENU_1500200300 = 1500200300,
  ORIGEMDERECURSO_MENU_1500300100 = 1500300100,
  PLANODEAPLICACAO_MENU_1500300200 = 1500300200,
  CONTACORRENTE_MENU_1500300300 = 1500300300,
  CADASTRODEPROJETOS_MENU_1590000001 = 1590000001,
  FISCALIZACAO_MENU_1590000002 = 1590000002,
  PARÂMETROS_MENU_1590000003 = 1590000003,
  RELATORIOSFISCALIZACAO_MENU_1590000004 = 1590000004,
  RELATORIOSPROJETOSESCOLA_MENU_1590000005 = 1590000005,
  SISTEMAPRESTACAODECONTAS_MENU_1590000006 = 1590000006,
  TREINAMENTOS_MENU_1600100100 = 1600100100,
  VIDEOTREINAMENTOS_MENU_1600100200 = 1600100200,
  CRIARTREINAMENTOS_MENU_1600100300 = 1600100300,
  CURSOS_MENU_1600200100 = 1600200100,
  CURSOS_MENU_1600200200 = 1600200200,
  AVALIAREAPROVARCURSOS_MENU_1600300100 = 1600300100,
  ALUNOSPORCURSOS_MENU_1600400100 = 1600400100,
  ESTATISTICAS_MENU_1600400200 = 1600400200,
  MEUSCURSOS_MENU_1600500100 = 1600500100,
  COORDENADOR_MENU_1690000001 = 1690000001,
  CRIADORDECONTEÚDO_MENU_1690000002 = 1690000002,
  RELATORIOS_MENU_1690000003 = 1690000003,
  SISTEMAEAD_MENU_1690000004 = 1690000004,
  TREINAMENTOSAEWEB_MENU_1690000005 = 1690000005,
  DASHBOARDS_MENU_1700100100 = 1700100100,
  RELATORIOSESTATISTICOS_MENU_1700200001 = 1700200001,
  ESTATISTICASESTUDANTE_MENU_1700200002 = 1700200002,
  ESTATISTICASADMINISTRATIVO_MENU_1700200003 = 1700200003,
  ALOCACAODEPROFESSORES_MENU_1700200004 = 1700200004,
  ALOCACAODEPROFESSORES_MENU_1700200014 = 1700200014,
  QUADROSESTATISTICOS_MENU_1700200005 = 1700200005,
  RELATORIOSESTATISTICOSUSUARIOS_MENU_1700200006 = 1700200006,
  RELATORIODEENTURMACOES_MENU_1700300002 = 1700300002,
  EVOLUCAODAQUANTIDADEDEESTUDANTES_MENU_1700300003 = 1700300003,
  FECHAMENTODETURMAS_MENU_1700300004 = 1700300004,
  RELACAODEESCOLAS_MENU_1700300005 = 1700300005,
  PREVISAODEVAGASGERAL_MENU_1700300006 = 1700300006,
  DASHBOARDALUNOS_MENU_1700300100 = 1700300100,
  NOTASEFALTAS_MENU_1700300101 = 1700300101,
  NOTASEFREQUENCIASPENDENTES_MENU_1700300102 = 1700300102,
  NOTASEFALTASDOBIMESTRE_MENU_1700300103 = 1700300103,
  ESTUDANTES_MENU_1700400001 = 1700400001,
  FUNCIONARIOS_MENU_1700400002 = 1700400002,
  ESTUDANTESGESTAONOVO_MENU_1700400099 = 1700400099,
  FUNCIONARIOSGESTAONOVO_MENU_1700400098 = 1700400098,
  DASHBOARDS_MENU_1790000001 = 1790000001,
  DASHBOARDSALUNO_MENU_1790000002 = 1790000002,
  DASHBOARDSAVALIACAO_MENU_1790000003 = 1790000003,
  DASHBOARDSCENSO_MENU_1790000004 = 1790000004,
  DASHBOARDSPENDENCIAS_MENU_1790000005 = 1790000005,
  DASHBOARDSPROFESSOR_MENU_1790000006 = 1790000006,
  EMITIRRELATORIOSGERENCIAIS_MENU_1790000007 = 1790000007,
  RELATORIOSDEESTATISTICA_MENU_1790000008 = 1790000008,
  SISTEMAESTATISTICAS_MENU_1790000009 = 1790000009,
  RELATORIOSGERAIS_MENU_1890000001 = 1890000001,
  SISTEMAREPORTS_MENU_1890000002 = 1890000002,
  /**
   * Editor de Relatórios Personalizados (Ferramentas): criar, alterar e excluir as visões de
   * REPORTS_PERSONALIZADOS. Tela nova, sem equivalente no legado — número vizinho ao do módulo de
   * relatórios (1890000002). Dá acesso a escrever SQL de LEITURA sobre a base do cliente: conceda
   * só a quem administra os relatórios da rede.
   */
  EDITORRELATORIOSPERSONALIZADOSNOVO_MENU_1890000099 = 1890000099,
  MATERIAIS_MENU_1900100100 = 1900100100,
  PADRAOESTOQUE_MENU_1900200100 = 1900200100,
  CENTRODEDISTRIBUICAO_MENU_1900200200 = 1900200200,
  PARÂMETROESCOLA_MENU_1900200300 = 1900200300,
  MOVIMENTACAO_MENU_1900200400 = 1900200400,
  LEVANTAMENTODEESTOQUE_MENU_1900200500 = 1900200500,
  ACOMPANHAMENTODEESTOQUE_MENU_1900200600 = 1900200600,
  CONTROLEDEESTOQUE_MENU_1900200700 = 1900200700,
  RELATORIODEMOVIMENTACAODEESTOQUE_MENU_1900200800 = 1900200800,
  REPOSICAOCONSUMOPREVISTO_MENU_1900300100 = 1900300100,
  SOLICITACAOPARAREPOSICAOESCOLA_MENU_1900300200 = 1900300200,
  SOLICITACAOPARAREPOSICAOCENTRAL_MENU_1900300300 = 1900300300,
  FORNECIMENTODEMATERIAL_MENU_1900300400 = 1900300400,
  ENTREGA_MENU_1900300500 = 1900300500,
  FORNECEDOR_MENU_1900400100 = 1900400100,
  CONTRATO_MENU_1900400200 = 1900400200,
  MEDICAO_MENU_1900400300 = 1900400300,
  SALDOCONTRATUAL_MENU_1900400400 = 1900400400,
  CLASSIFICACAODEMATERIAIS_MENU_1900500100 = 1900500100,
  TIPODEMATERIAIS_MENU_1900500200 = 1900500200,
  UNIDADEDEMEDIDA_MENU_1900500300 = 1900500300,
  EMBALAGEM_MENU_1900500400 = 1900500400,
  TIPOFORNECIMENTO_MENU_1900500500 = 1900500500,
  TIPODEPERDAS_MENU_1900500600 = 1900500600,
  ROTA_MENU_1900500700 = 1900500700,
  ENTREGADEMATERIAIS_MENU_1990000001 = 1990000001,
  FORNECEDOR_MENU_1990000002 = 1990000002,
  FORNECIMENTODEMATERIAIS_MENU_1990000003 = 1990000003,
  LANCAMENTOSCENTRODISTRIBUICAO_MENU_1990000004 = 1990000004,
  LANCAMENTOSESCOLA_MENU_1990000005 = 1990000005,
  PARÂMETROSDETODASASESCOLAS_MENU_1990000006 = 1990000006,
  PARÂMETROSESTOQUE_MENU_1990000007 = 1990000007,
  RELATORIOSDEESTOQUE_MENU_1990000008 = 1990000008,
  RELATORIOSMEDICAO_MENU_1990000009 = 1990000009,
  SISTEMAESTOQUE_MENU_1990000010 = 1990000010,
  SOLICITACAOPARAREPOSICAOCENTRAL_MENU_1990000011 = 1990000011,
  SOLICITACAOPARAREPOSICAOESCOLA_MENU_1990000012 = 1990000012,
  ALOCACAOAUTOMATICADEUNIFORME_MENU_2000100100 = 2000100100,
  ENTREGAUNIFORMEPORTURMA_MENU_2000100200 = 2000100200,
  ENTREGAKITESCOLARPORTURMA_MENU_2000100300 = 2000100300,
  ENTREGALIVRODIDATICOPORTURMA_MENU_2000100400 = 2000100400,
  ENTREGALIVRODIDATICOPORESTUDANTES_MENU_2000100500 = 2000100500,
  DEVOLUCAOLIVRODIDATICOPORESTUDANTES_MENU_2000100600 = 2000100600,
  ACOMPANHAMENTODEENTREGADEUNIFORMES,
  KITS_MENU_2000100700 = 2000100700,
  ACOMPANHAMENTODEENTREGAEDEVOLUCAODELIVRODIDATICO_MENU_2000100800 = 2000100800,
  SOLICITACAOUNIFORME_MENU_2000200100 = 2000200100,
  SOLICITACAOKITESCOLAR_MENU_2000200200 = 2000200200,
  SOLICITACAOLIVRODIDATICO_MENU_2000200300 = 2000200300,
  ATENDIMENTOSOLICITACAOUNIFORME_MENU_2000300100 = 2000300100,
  ATENDIMENTOSOLICITACAOKITESCOLAR_MENU_2000300200 = 2000300200,
  ATENDIMENTOSOLICITACAOLIVRODIDATICO_MENU_2000300300 = 2000300300,
  KITDEMATERIALESCOLAR_MENU_2000400100 = 2000400100,
  KITPORSERIE_MENU_2000400200 = 2000400200,
  UNIFORME_MENU_2000400300 = 2000400300,
  LIVRODIDATICO_MENU_2000400400 = 2000400400,
  UNIFORMESERVIDOR_MENU_2000400500 = 2000400500,
  ACESSARMENUUNIFORMEKITESCOLAR_MENU_2090000001 = 2090000001,
  ATENDESOLICITACAODEUNIFORMEKITESCOLAR_MENU_2090000002 = 2090000002,
  CADASTRAUNIFORMEKITESCOLAR_MENU_2090000003 = 2090000003,
  ATA_MENU_2100100100 = 2100100100,
  PLANEJAMENTODEREUNIOES_MENU_2100100200 = 2100100200,
  PLANODEACAO_MENU_2100100300 = 2100100300,
  PESQUISAASSUNTO_MENU_2100100400 = 2100100400,
  ACOMPANHAMENTOPLANOACAO_MENU_2100100500 = 2100100500,
  TIPODEREUNIAO_MENU_2100200100 = 2100200100,
  ASSOCIACAODEPAIS_MENU_2100200200 = 2100200200,
  CONSELHOESCOLAR_MENU_2100200300 = 2100200300,
  GREMIOESTUDANTIL_MENU_2100200400 = 2100200400,
  ACESSARMENUATA_MENU_2190000001 = 2190000001,
  CADASTRARATAS_MENU_2190000002 = 2190000002,
  RELATORIOSATAS_MENU_2190000003 = 2190000003,
  BLOQUEIOLIBERACAODEETAPAPORENSINO_MENU_2200001010 = 2200001010,
  BLOQUEIOLIBERACAODEETAPAPORPROFESSOR_MENU_2200001020 = 2200001020,
  ETAPAPORENSINOGERAL_MENU_2200001030 = 2200001030,
  DADOSDAESCOLA_MENU_2200100100 = 2200100100,
  HISTORICODEPUBLICACAO_MENU_2200100200 = 2200100200,
  INDICADORIDEB_MENU_2200100300 = 2200100300,
  TIPODEESCOLA_MENU_2200100400 = 2200100400,
  REGIONALDEENSINO_MENU_2200100500 = 2200100500,
  ALTERARIMAGEMLOGOLOGIN_MENU_2200100600 = 2200100600,
  PARÂMETROS_MENU_2200100700 = 2200100700,
  CONFIGURACOES_MENU_2200100800 = 2200100800,
  /**
   * Configuração de envios (e-mail, SMS e WhatsApp) por rede e por escola. Não tem equivalente
   * no legado — fica ao lado de Configurações (2200100800) na Administração.
   */
  CONFIGURACAODEENVIOSNOVO_MENU_2200100850 = 2200100850,
  /**
   * Envio de e-mail, SMS e WhatsApp para a REDE inteira (todas as escolas, ou as escolhidas) —
   * a secretaria de educação falando com as famílias da rede. Usa SEMPRE a configuração de envio
   * da rede. Sem equivalente no legado.
   */
  ENVIARMENSAGENSREDENOVO_MENU_2200100851 = 2200100851,
  /**
   * Usar a assistente virtual Sofia. Permissão PURA (sem tela nem rota): sem ela o grupo não vê
   * o atalho flutuante nem o item "Fale com a Sofia", e o front nem pergunta à API da IA se ela
   * está no ar (`sessionService.PodeUsarSofia()`). Suporte/desenvolvimento passam sem cadastro.
   */
  USARASSISTENTESOFIA_MENU_2200100860 = 2200100860,
  CADASTROEDUCACENSO_MENU_2200100900 = 2200100900,
  ENSINOSESPECIFICOS_MENU_2200101000 = 2200101000,
  ENSINOSESPECIFICOSNOVO_MENU_2200101001 = 2200101001,
  COPIARENSINOEPLANOSANTERIORES_MENU_2200101100 = 2200101100,
  /** Tela nova de cópia do ano anterior — nunca a 2200101100 do legado. */
  COPIARENSINOEPLANOSANTERIORESNOVO_MENU_2200101101 = 2200101101,
  EDUCACENSO_MENU_2200101200 = 2200101200,
  IMPORTACAODOANOANTERIOR_MENU_2200101201 = 2200101201,
  EDUCACENSO1ETAPA_MENU_2200101202 = 2200101202,
  GERARARQUIVOMATRICULAINICIAL_MENU_2200101203 = 2200101203,
  EDUCACENSO2ETAPA_MENU_2200101204 = 2200101204,
  GERARARQUIVOSITUACAOFINAL_MENU_2200101205 = 2200101205,
  ACESSARLOGDEREGISTROS_MENU_2200101300 = 2200101300,
  ACESSARLOGDENOTAS_MENU_2200101400 = 2200101400,
  ACESSARLOGDECONTEUDOLECIONADO_MENU_2200101500 = 2200101500,
  UNIFICARESTUDANTESDUPLICADOS_MENU_2200101600 = 2200101600,
  /** Tela nova de unificação de estudantes — nunca a 2200101600 do legado. */
  UNIFICARESTUDANTESDUPLICADOSNOVO_MENU_2200101601 = 2200101601,
  UNIFICARFUNCIONARIOSDUPLICADOS_MENU_2200101700 = 2200101700,
  /** Tela nova de unificação de funcionários — nunca a 2200101700 do legado. */
  UNIFICARFUNCIONARIOSDUPLICADOSNOVO_MENU_2200101701 = 2200101701,
  /**
   * Manutenção de Alocações (Administração → Ferramentas) — só suporte. Tela nova sem equivalente
   * no legado; número vizinho da unificação de cadastros. Ver docs/manutencao-alocacoes/.
   */
  MANUTENCAODEALOCACOESNOVO_MENU_2200101702 = 2200101702,
  PARÂMETROSDEMATRICULASESTUDANTES_MENU_2200101800 = 2200101800,
  PARÂMETROSDEMATRICULASPESSOAL_MENU_2200101900 = 2200101900,
  CONFIGURACOESDEPREMATRICULAS_MENU_2200102000 = 2200102000,
  DOCUMENTOSQUESTIONARIOMATRICULASONLINE_MENU_2200102100 = 2200102100,
  COPIADEPLANOENTREESCOLAS_MENU_2200102200 = 2200102200,
  VERIFICACAOESTRUTURABANCOS_MENU_2200102300 = 2200102300,
  PERIODODEABERTURADEVAGAS_MENU_2200200100 = 2200200100,
  CONFIGURACAODEVAGASPARAPREMATRICULA_MENU_2200200200 = 2200200200,
  CADASTRO_MENU_2200300100 = 2200300100,
  ESTRUTURADOSPORTAIS_MENU_2200400100 = 2200400100,
  SERIEDOSPORTAIS_MENU_2200400200 = 2200400200,
  ASSINATURADOSPORTAIS_MENU_2200400201 = 2200400201,
  EVENTOS_MENU_2200400300 = 2200400300,
  INFORMATIVO_MENU_2200400400 = 2200400400,
  LINKS_MENU_2200400500 = 2200400500,
  PERGUNTASFREQUENTES_MENU_2200400600 = 2200400600,
  IMAGENSECARTOES_MENU_2200400700 = 2200400700,
  ATIVIDADESPEDAGOGICAS_MENU_2200400800 = 2200400800,
  ACESSARMENUCAMPANHAS_MENU_2290000001 = 2290000001,
  ACESSARMENUDIARIOELETRONICO_MENU_2290000002 = 2290000002,
  ACESSARMENUESCOLA_MENU_2290000003 = 2290000003,
  ACESSARPENDENCIASDOCENSOESCOLA_MENU_2290000004 = 2290000004,
  ACESSARPERIODODEABERTURADEVAGAS_MENU_2290000005 = 2290000005,
  ALTERARCONFIGURACOESDAESCOLA_MENU_2290000006 = 2290000006,
  ALTERARDADOSDAESCOLA_MENU_2290000007 = 2290000007,
  BLOQUEIOLIBERACAODEETAPAPORENSINO_MENU_2290000008 = 2290000008,
  BLOQUEIOLIBERACAODEETAPAPORENSINOGERAL_MENU_2290000009 = 2290000009,
  BLOQUEIOLIBERACAODEETAPAPORPROFESSOR_MENU_2290000010 = 2290000010,
  /** Tela NOVA de etapa atual por ensino (Vue). Absorveu também a antiga tela Geral. */
  BLOQUEIOLIBERACAODEETAPAPORENSINONOVO_MENU_2290000099 = 2290000099,
  /** Tela NOVA de liberação de lançamento por professor (Vue). */
  BLOQUEIOLIBERACAODEETAPAPORPROFESSORNOVO_MENU_2290000098 = 2290000098,
  CADASTRARESCOLA_MENU_2290000011 = 2290000011,
  CADASTRODOEDUCACENSO_MENU_2290000012 = 2290000012,
  COPIARENSINOSDOANOANTERIOR_MENU_2290000013 = 2290000013,
  DEFINIRHABILITACOES_MENU_2290000014 = 2290000014,
  ENSINOESPECIFICODAESCOLA_MENU_2290000015 = 2290000015,
  EXPORTACAODOEDUCACENSO_MENU_2290000016 = 2290000016,
  LANCAMENTOUNIFICADODEETAPAS_MENU_2290000017 = 2290000017,
  PUBLICARNOVIDADES_MENU_2290000018 = 2290000018,
  SUPERVISORACESSAAPENASTURNOQUETRABALHA_MENU_2290000019 = 2290000019,
  UNIFICARESTUDANTESDUPLICADOS_MENU_2290000020 = 2290000020,
  ESTRUTURADOPDI_MENU_2300100100 = 2300100100,
  NOVO_PDI_ESTRUTURA_SUBMENU_2300100150 = 2300100150,
  NOVO_PDI_ANAMNESE_2300100151 = 2300100151,
  NOVO_PDI_PENDENTE_2300100152 = 2300100152,
  NOVO_PDI_ESTRUTURA_2300100153 = 2300100153,
  SERIEDOPDI_MENU_2300100200 = 2300100200,
  ASSINATURADOPDI_MENU_2300100201 = 2300100201,
  PDIALUNO_MENU_2300100300 = 2300100300,
  PDIPENDENTE_MENU_2300100400 = 2300100400,
  DADOSALUNOPDIRESOLUCAO_MENU_2300100500 = 2300100500,
  ESTRUTURADOPPI_MENU_2300200100 = 2300200100,
  SERIEDOPPI_MENU_2300200200 = 2300200200,
  ASSINATURADOPPI_MENU_2300200201 = 2300200201,
  PPIALUNOCONTEÚDOS_MENU_2300200300 = 2300200300,
  PPIALUNOAEE_MENU_2300200400 = 2300200400,
  PPIALUNOAVALIACAODESCRITIVA_MENU_2300200500 = 2300200500,
  PPIPENDENTE_MENU_2300200600 = 2300200600,
  ACESSARMENUEDUCINCLUSIVA_MENU_2390000001 = 2390000001,
  GESTAO_PARAMETROS = 2400000001,
  RELATORIO_NOTAS_PARCIAIS_TOTAIS_MENU_300802908 = 300802908,
  FERRAMENTAS_PASTAS_MENU_2500100100 = 2500100100,
  FERRAMENTAS_DADOS_MENU_2500100200 = 2500100200,
  FERRAMENTAS_CABECALHOSERODAPES_MENU_2500100300 = 2500100300,
  FERRAMENTAS_RELATORIOS_MENU_2500100400 = 2500100400,
  FERRAMENTAS_CONFIGURACOES_MENU_2500200010 = 2500200010,
  FERRAMENTAS_LOG_MENU_2500200100 = 2500200100,
  FERRAMENTAS_MONITORAMENTO_MENU_2500200200 = 2500200200,
  FERRAMENTAS_GERADOR_MENU_2500300100 = 2500300100,
  FERRAMENTAS_CADASTRO_MENU_2500400100 = 2500400100,
  FERRAMENTAS_ARQUIVOS_MENU_2500500100 = 2500500100,
  FERRAMENTAS_DASHBOARD_MENU_2500600100 = 2500600100,
  FERRAMENTAS_GESTAO_ATIVIDADES_MENU_2500700100 = 2500700100,
  // colocar recurso do gestão de permissões
  GESTAO_PERMISSOES_MENU_900100101 = 900100101,
  GESTAO_USUARIOS_GRUPOS_MENU_900100201 = 900100201,
  ATENDIMENTO_CADASTROS_NOVO_MENU_3200100100 = 3200100100,
  ATENDIMENTO_ANALISES_NOVO_MENU_3200100200 = 3200100200,
  ATENDIMENTO_SERVICOS_NOVO_MENU_3200100300 = 3200100300,
  ATENDIMENTO_AGENDA_NOVO_MENU_3200100400 = 3200100400,
  ATENDIMENTO_PRONTUARIO_NOVO_MENU_3200100500 = 3200100500,
  ATENDIMENTO_RELATORIOS_NOVO_MENU_3200100600 = 3200100600,
  ATENDIMENTO_AVISOS_SECRETARIA_NOVO_MENU_3200100710 = 3200100710,
  ATENDIMENTO_AVISOS_APOIO_NOVO_MENU_3200100720 = 3200100720,
  ATENDIMENTO_CONFIGURACAO_NOVO_MENU_3200100800 = 3200100800,
  ATENDIMENTO_PORTAL_NOVO_MENU_3200100900 = 3200100900,
  ATENDIMENTO_REL_ANALISESANALITICO_NOVO_MENU_3200106101 = 3200106101,
  ATENDIMENTO_REL_ANALISES_NOVO_MENU_3200106102 = 3200106102,
  ATENDIMENTO_REL_PENDENTES_NOVO_MENU_3200106103 = 3200106103,
  ATENDIMENTO_REL_PENDENTESSINTETICO_NOVO_MENU_3200106104 = 3200106104,
  ATENDIMENTO_REL_MOVIMENTACOESANALITICO_NOVO_MENU_3200106105 = 3200106105,
  ATENDIMENTO_REL_MOVIMENTACOES_NOVO_MENU_3200106106 = 3200106106,
  ATENDIMENTO_REL_SERVICOSANALITICO_NOVO_MENU_3200106107 = 3200106107,
  ATENDIMENTO_REL_SERVICOSSINTETICO_NOVO_MENU_3200106108 = 3200106108,
  ATENDIMENTO_REL_PARTICIPANTESANALITICO_NOVO_MENU_3200106109 = 3200106109,
  ATENDIMENTO_REL_PARTICIPANTESSINTETICO_NOVO_MENU_3200106110 = 3200106110,
  ATENDIMENTO_REL_GRUPOSANALITICO_NOVO_MENU_3200106111 = 3200106111,
  ATENDIMENTO_REL_GRUPOSSINTETICO_NOVO_MENU_3200106112 = 3200106112,
  ATENDIMENTO_REL_AGENDA_NOVO_MENU_3200106113 = 3200106113,
  ATENDIMENTO_REL_AGENDASINTETICO_NOVO_MENU_3200106114 = 3200106114,
  ATENDIMENTO_REL_FREQUENCIAANALITICO_NOVO_MENU_3200106115 = 3200106115,
  ATENDIMENTO_REL_FREQUENCIASINTETICO_NOVO_MENU_3200106116 = 3200106116,
  ATENDIMENTO_REL_ESPERAANALITICO_NOVO_MENU_3200106117 = 3200106117,
  ATENDIMENTO_REL_ESPERASINTETICO_NOVO_MENU_3200106118 = 3200106118,
  ATENDIMENTO_REL_FALTASANALITICO_NOVO_MENU_3200106119 = 3200106119,
  ATENDIMENTO_REL_FALTASSINTETICO_NOVO_MENU_3200106120 = 3200106120,
  ATENDIMENTO_REL_PRONTUARIO_NOVO_MENU_3200106121 = 3200106121,
  ATENDIMENTO_REL_PRONTUARIOSINTETICO_NOVO_MENU_3200106122 = 3200106122,
  ATENDIMENTO_REL_AVISOSSECRETARIAANALITICO_NOVO_MENU_3200106123 = 3200106123,
  ATENDIMENTO_REL_AVISOSSECRETARIASINTETICO_NOVO_MENU_3200106124 = 3200106124,
  ATENDIMENTO_REL_AVISOSAPOIOANALITICO_NOVO_MENU_3200106125 = 3200106125,
  ATENDIMENTO_REL_AVISOSAPOIOSINTETICO_NOVO_MENU_3200106126 = 3200106126,
  ATENDIMENTO_REL_CATALOGOSANALITICO_NOVO_MENU_3200106127 = 3200106127,
  ATENDIMENTO_REL_CATALOGOSSINTETICO_NOVO_MENU_3200106128 = 3200106128,
  ATENDIMENTO_REL_TERAPEUTASANALITICO_NOVO_MENU_3200106129 = 3200106129,
  ATENDIMENTO_REL_TERAPEUTASSINTETICO_NOVO_MENU_3200106130 = 3200106130,
  ATENDIMENTO_REL_COMPROVANTE_NOVO_MENU_3200106131 = 3200106131,
  ATENDIMENTO_REL_DESISTENCIA_NOVO_MENU_3200106132 = 3200106132,

  /*
   * Permissões PRÓPRIAS das telas novas que usavam a permissão do legado (ou a de outra tela).
   * Cada tela tem a sua: a rede libera a nova sem mexer na antiga, e vice-versa. Um script por banco:
   * CONSULTEBASE (menus) — saeweb-database-sql/consultebase/scripts/2026-10-27-Permissoes-Proprias-TelasNovas.sql
   * SAEWEBBASE (rotas da API) — docs/sql/permissoes-proprias/001_saewebbase_vinculos_permissoes_proprias.sql
   */
  PAINELDOESTUDANTENOVO_MENU_300100050 = 300100050,
  COMPROVANTEDEMATRICULANOVO_MENU_300201199 = 300201199,
  TRAJETORIADEMATRICULANOVO_MENU_300201399 = 300201399,
  DECLARACAODEMATRICULANOVO_MENU_300700499 = 300700499,
  CONTEUDOLECIONADONOVO_MENU_300301299 = 300301299,
  PORTURMANOVO_MENU_300800301 = 300800301,
  TRANSPORTEDEESTUDANTESNOVO_MENU_300801099 = 300801099,
  CONTEUDOSCURRICULARESNOVO_MENU_300900499 = 300900499,
  FUNCAOORIGINALDASALANOVO_MENU_300900193 = 300900193,
  UTILIZACAODASALANOVO_MENU_300900194 = 300900194,
  DADOSDAESCOLANOVO_MENU_2200100099 = 2200100099,
  PESSOASNOVO_MENU_2200100101 = 2200100101,
  CALENDARIOREDEDEENSINONOVO_MENU_200100199 = 200100199,
  CALENDARIOUNIDADEESCOLARNOVO_MENU_200100299 = 200100299,
  ATIVIDADESNOVO_MENU_200200199 = 200200199,
  FERIADOSNOVO_MENU_200300199 = 200300199,
  PARALISACOESNOVO_MENU_200300299 = 200300299,
  NECESSIDADEDIARIANOVO_MENU_1000200199 = 1000200199,
  TIPODEREFEICAONOVO_MENU_1000200299 = 1000200299,
  CARDAPIONOVO_MENU_1000200399 = 1000200399,
  PREPARACAONOVO_MENU_1000200499 = 1000200499,
  CALENDARIOCARDAPIONOVO_MENU_1000200699 = 1000200699,
  COMENSAISPORESCOLANOVO_MENU_1000200799 = 1000200799,
  REFEICOESSERVIDASNOVO_MENU_1000200899 = 1000200899,
  TIPODEMOVIMENTONOVO_MENU_1000600950 = 1000600950,
  LEVANTAMENTODEESTOQUEALIMENTACAONOVO_MENU_1000300599 = 1000300599,
  LEVANTAMENTODEESTOQUEESCOLANOVO_MENU_1900200599 = 1900200599,
  LEVANTAMENTODEESTOQUECENTRALNOVO_MENU_1900200550 = 1900200550,
  MOVIMENTACAOALIMENTACAONOVO_MENU_1000300499 = 1000300499,
  MOVIMENTACAOESTOQUEESCOLANOVO_MENU_1900200499 = 1900200499,
  MOVIMENTACAOCENTRALNOVO_MENU_1900200450 = 1900200450,
  MOTIVOESTORNONOVO_MENU_1900500650 = 1900500650,
  CENTRODEDISTRIBUICAONOVO_MENU_1000300299 = 1000300299,
  ITENSDEBALANCEAMENTONOVO_MENU_1000600299 = 1000600299,
  CLASSIFICACAOTACONOVO_MENU_1000600619 = 1000600619,
  UNIDADEDEMEDIDANOVO_MENU_1000600399 = 1000600399,
  EMBALAGEMNOVO_MENU_1000600499 = 1000600499,
  DIETAESPECIALNOVO_MENU_1000600599 = 1000600599,
  ROTANOVO_MENU_1000600799 = 1000600799,
  MATERIAISNOVO_MENU_1900100199 = 1900100199,
  ALIMENTOSNOVO_MENU_1000100199 = 1000100199,
  PADRAOESTOQUENOVO_MENU_1900200199 = 1900200199,
  PADRAOESCOLANOVO_MENU_1900200399 = 1900200399,
  SOLICITACAOREPOSICAOESCOLANOVO_MENU_1900300299 = 1900300299,
  SOLICITACAOREPOSICAOALIMENTACAONOVO_MENU_1000400299 = 1000400299,
  SOLICITACAOREPOSICAOCENTRALNOVO_MENU_1900300399 = 1900300399,
  FORNECIMENTODEMATERIALNOVO_MENU_1900300499 = 1900300499,
  FORNECIMENTODIRETONOVO_MENU_1000400459 = 1000400459,
  CLASSIFICACAODEMATERIAISNOVO_MENU_1900500199 = 1900500199,
  TIPODEMATERIAISNOVO_MENU_1900500299 = 1900500299,
  TIPODEPERDASNOVO_MENU_1900500699 = 1900500699,
  CONTRATONOVO_MENU_1900400299 = 1900400299,
  MEDICAONOVO_MENU_1900400399 = 1900400399,
  VIAGEMNOVO_MENU_1100200199 = 1100200199,
  VEICULOSNOVO_MENU_1100200299 = 1100200299,
  USUARIOSEXTERNOSDOTRANSPORTENOVO_MENU_1100400299 = 1100400299,
  PARAMETROSTRANSPORTENOVO_MENU_1100400199 = 1100400199,
  RELATORIOALUNOSTRANSPORTENOVO_MENU_1100100699 = 1100100699,
  BEMNOVO_MENU_1200100199 = 1200100199,
  ALOCACAODETIPODEBENSNOVO_MENU_1200200199 = 1200200199,
  LISTADEINVENTARIONOVO_MENU_1200300199 = 1200300199,
  ESTADODECONSERVACAONOVO_MENU_1200300299 = 1200300299,
  FORMADETOMBAMENTONOVO_MENU_1200300399 = 1200300399,
  MOTIVODEBAIXANOVO_MENU_1200300499 = 1200300499,
  RESPONSAVELPATRIMONIONOVO_MENU_1200300599 = 1200300599,
  RELATORIOPATRIMONIONOVO_MENU_1200400199 = 1200400199,
  RELATORIOBAIXASNOVO_MENU_1200400299 = 1200400299,
  PLANEJAMENTOPATRIMONIALNOVO_MENU_1200200299 = 1200200299,
  ENCERRAMENTODEINVENTARIONOVO_MENU_1200200399 = 1200200399,
  BIB_CATALOGACAONOVO_MENU_1300100199 = 1300100199,
  BIB_SUGESTOESDEAQUISICAONOVO_MENU_1300100198 = 1300100198,
  BIB_PESQUISAPALAVRACHAVENOVO_MENU_1300200299 = 1300200299,
  BIB_CADASTROPALAVRACHAVENOVO_MENU_1300200199 = 1300200199,
  BIB_EXEMPLARESCOLANOVO_MENU_1300100299 = 1300100299,
  BIB_EXEMPLARCENTRALNOVO_MENU_1300100399 = 1300100399,
  BIB_EMPRESTIMOESCOLANOVO_MENU_1300400399 = 1300400399,
  BIB_EMPRESTIMOCENTRALNOVO_MENU_1300400359 = 1300400359,
  BIB_RESERVAESCOLANOVO_MENU_1300400199 = 1300400199,
  BIB_RESERVACENTRALNOVO_MENU_1300400159 = 1300400159,
  BIB_CONTROLEEMPRESTIMORESERVAESCOLANOVO_MENU_1300400599 = 1300400599,
  BIB_CONTROLEEMPRESTIMORESERVACENTRALNOVO_MENU_1300400699 = 1300400699,
  BIB_ETIQUETANOVO_MENU_1300500199 = 1300500199,
  BIB_CONFIGURARETIQUETASNOVO_MENU_1300500198 = 1300500198,
  BIB_ESTATISTICANOVO_MENU_1300600799 = 1300600799,
  BIB_TIPODEDOCUMENTONOVO_MENU_1300800199 = 1300800199,
  BIB_TIPOSDEMIDIANOVO_MENU_1300800299 = 1300800299,
  BIB_CLASSIFICACAODEOBRASNOVO_MENU_1300800399 = 1300800399,
  BIB_CLASSIFICACAOPORCORNOVO_MENU_1300800499 = 1300800499,
  BIB_AUTORNOVO_MENU_1300800599 = 1300800599,
  BIB_ENTIDADENOVO_MENU_1300800699 = 1300800699,
  BIB_EDITORANOVO_MENU_1300800799 = 1300800799,
  BIB_LOCALDEPUBLICACAONOVO_MENU_1300800899 = 1300800899,
  BIB_EVENTONOVO_MENU_1300800999 = 1300800999,
  BIB_FORMASDEAQUISICAONOVO_MENU_1300801099 = 1300801099,
  BIB_MOEDANOVO_MENU_1300801199 = 1300801199,
  BIB_MOTIVODADISPENSADEMULTANOVO_MENU_1300801299 = 1300801299,
  BIB_MOTIVOBAIXANOVO_MENU_1300801399 = 1300801399,
  BIB_MOTIVOBLOQUEIOUSUARIONOVO_MENU_1300801499 = 1300801499,
  BIB_LOCALIZACAOFISICAOBRASNOVO_MENU_1300801599 = 1300801599,
  BIB_IDIOMASNOVO_MENU_1300801699 = 1300801699,
  BIB_AREADEINTERESSENOVO_MENU_1300801799 = 1300801799,
  BIB_AREADECONHECIMENTONOVO_MENU_1300801899 = 1300801899,
  BIB_CONFIGURACAOBIBLIOTECANOVO_MENU_1300801999 = 1300801999,
  BIB_CUTTERNOVO_MENU_1300801998 = 1300801998,
  BIB_PARAMETROSUSUARIOSNOVO_MENU_1300300199 = 1300300199,
  BIB_AREADEINTERESSEUSUARIONOVO_MENU_1300300299 = 1300300299,
  BIB_BLOQUEIODESBLOQUEIONOVO_MENU_1300300399 = 1300300399,
  SERVIDORNOVO_MENU_1400100199 = 1400100199,
  FUNCOESNOVO_MENU_1400400199 = 1400400199,
  FUNCAOESCOLANOVO_MENU_1400400299 = 1400400299,
  ALTERACAODEDESIGNACAONOVO_MENU_1400400399 = 1400400399,
  HISTORICOFUNCIONALNOVO_MENU_1400200199 = 1400200199,
  RELATORIOAFASTAMENTOSNOVO_MENU_1400200198 = 1400200198,
  TITULACAONOVO_MENU_1400800399 = 1400800399,
  TIPODECURSONOVO_MENU_1400800599 = 1400800599,
  ESTRUTURAORGANIZACIONALNOVO_MENU_1400700199 = 1400700199,
  AREADEFORMACAONOVO_MENU_1400800199 = 1400800199,
  CARGOSEFUNCOESNOVO_MENU_1400700799 = 1400700799,
  CARGOCOMISSIONADONOVO_MENU_1400700899 = 1400700899,
  IDIOMANOVO_MENU_1400800499 = 1400800499,
  LICENCASNOVO_MENU_1400701299 = 1400701299,
  PROVIMENTONOVO_MENU_1400701399 = 1400701399,
  QUADRONOVO_MENU_1400700599 = 1400700599,
  BENEFICIOSNOVO_MENU_1400700999 = 1400700999,
  TIPODEDESLIGAMENTONOVO_MENU_1400701199 = 1400701199,
  TIPODEMOVIMENTACAONOVO_MENU_1400701099 = 1400701099,
  TIPODEOCORRENCIANOVO_MENU_1400700198 = 1400700198,
  TIPODEPROVENTODESCONTOVARIAVELNOVO_MENU_1400801059 = 1400801059,
  TIPODETITULACAONOVO_MENU_1400800299 = 1400800299,
  VINCULOEMPREGATICIONOVO_MENU_1400700699 = 1400700699,
  FORNECEDORNOVO_MENU_1900400199 = 1900400199,
  PARTICIPANTESNOVO_MENU_2100200299 = 2100200299,
  GRUPODEPARTICIPANTESNOVO_MENU_2100200298 = 2100200298,
  CONVENIOPROJETOSNOVO_MENU_1500100199 = 1500100199,
  CONCILIACAOBANCARIANOVO_MENU_1500100399 = 1500100399,
  CONTACORRENTENOVO_MENU_1500300399 = 1500300399,
  MOVIMENTACAOBANCARIANOVO_MENU_2900200199 = 2900200199,
  ORIGEMDERECURSONOVO_MENU_1500300199 = 1500300199,
  PLANEJAMENTOSECRETARIANOVO_MENU_2900100199 = 2900100199,
  PLANOCONTASNOVO_MENU_2900400299 = 2900400299,
  DILIGENCIASNOVO_MENU_1500200199 = 1500200199,
  PRESTACAODECONTASNOVO_MENU_1500100499 = 1500100499,
}
